var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 720,
    viewBox: "0 0 1440 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 720,
    fill: "url(#paint0_linear_140_2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_140_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.62022 6.32617L23.7595 20.9706V50.2595L-1.62022 64.904L-27 50.2595V20.9706L-1.62022 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 6.32617L85.5919 20.9706V50.2595L60.2122 64.904L34.8325 50.2595V20.9706L60.2122 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 6.32617L147.424 20.9706V50.2595L122.045 64.904L96.6649 50.2595V20.9706L122.045 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 6.32617L209.257 20.9706V50.2595L183.877 64.904L158.497 50.2595V20.9706L183.877 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 6.32617L271.089 20.9706V50.2595L245.709 64.904L220.33 50.2595V20.9706L245.709 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 6.32617L332.922 20.9706V50.2595L307.542 64.904L282.162 50.2595V20.9706L307.542 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 6.32617L394.754 20.9706V50.2595L369.374 64.904L343.995 50.2595V20.9706L369.374 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 6.32617L456.586 20.9706V50.2595L431.207 64.904L405.827 50.2595V20.9706L431.207 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 6.32617L518.419 20.9706V50.2595L493.039 64.904L467.659 50.2595V20.9706L493.039 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.872 6.32617L580.251 20.9706V50.2595L554.872 64.904L529.492 50.2595V20.9706L554.872 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 6.32617L642.084 20.9706V50.2595L616.704 64.904L591.324 50.2595V20.9706L616.704 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 112.539L23.7595 127.183V156.472L-1.62027 171.117L-27 156.472V127.183L-1.62027 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 112.539L85.5919 127.183V156.472L60.2122 171.117L34.8324 156.472V127.183L60.2122 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 112.539L147.424 127.183V156.472L122.045 171.117L96.6648 156.472V127.183L122.045 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 112.539L209.257 127.183V156.472L183.877 171.117L158.497 156.472V127.183L183.877 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 112.539L271.089 127.183V156.472L245.709 171.117L220.33 156.472V127.183L245.709 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 112.539L332.922 127.183V156.472L307.542 171.117L282.162 156.472V127.183L307.542 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 112.539L394.754 127.183V156.472L369.374 171.117L343.995 156.472V127.183L369.374 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 112.539L456.586 127.183V156.472L431.207 171.117L405.827 156.472V127.183L431.207 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 112.539L518.419 127.183V156.472L493.039 171.117L467.659 156.472V127.183L493.039 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 112.539L580.251 127.183V156.472L554.871 171.117L529.492 156.472V127.183L554.871 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 112.539L642.084 127.183V156.472L616.704 171.117L591.324 156.472V127.183L616.704 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 218.751L23.7595 233.396V262.685L-1.62027 277.329L-27 262.685V233.396L-1.62027 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 218.751L85.5919 233.396V262.685L60.2122 277.329L34.8324 262.685V233.396L60.2122 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 218.751L147.424 233.396V262.685L122.045 277.329L96.6648 262.685V233.396L122.045 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 218.751L209.257 233.396V262.685L183.877 277.329L158.497 262.685V233.396L183.877 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 218.751L271.089 233.396V262.685L245.709 277.329L220.33 262.685V233.396L245.709 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 218.751L332.922 233.396V262.685L307.542 277.329L282.162 262.685V233.396L307.542 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 218.751L394.754 233.396V262.685L369.374 277.329L343.995 262.685V233.396L369.374 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 218.751L456.586 233.396V262.685L431.207 277.329L405.827 262.685V233.396L431.207 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 218.751L518.419 233.396V262.685L493.039 277.329L467.659 262.685V233.396L493.039 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 218.751L580.251 233.396V262.685L554.871 277.329L529.492 262.685V233.396L554.871 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 218.751L642.084 233.396V262.685L616.704 277.329L591.324 262.685V233.396L616.704 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 324.964L23.7595 339.608V368.897L-1.62027 383.542L-27 368.897V339.608L-1.62027 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 324.964L85.5919 339.608V368.897L60.2122 383.542L34.8324 368.897V339.608L60.2122 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 324.964L147.424 339.608V368.897L122.045 383.542L96.6648 368.897V339.608L122.045 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 324.964L209.257 339.608V368.897L183.877 383.542L158.497 368.897V339.608L183.877 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 324.964L271.089 339.608V368.897L245.709 383.542L220.33 368.897V339.608L245.709 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 324.964L332.922 339.608V368.897L307.542 383.542L282.162 368.897V339.608L307.542 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 324.964L394.754 339.608V368.897L369.374 383.542L343.995 368.897V339.608L369.374 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 324.964L456.586 339.608V368.897L431.207 383.542L405.827 368.897V339.608L431.207 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 324.964L518.419 339.608V368.897L493.039 383.542L467.659 368.897V339.608L493.039 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 324.964L580.251 339.608V368.897L554.871 383.542L529.492 368.897V339.608L554.871 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 324.964L642.084 339.608V368.897L616.704 383.542L591.324 368.897V339.608L616.704 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 59.1105L54.6757 73.7549V103.044L29.296 117.688L3.91625 103.044V73.7549L29.296 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 59.1105L116.508 73.7549V103.044L91.1284 117.688L65.7487 103.044V73.7549L91.1284 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 59.1105L178.341 73.7549V103.044L152.961 117.688L127.581 103.044V73.7549L152.961 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 59.1105L240.173 73.7549V103.044L214.793 117.688L189.414 103.044V73.7549L214.793 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 59.1105L302.005 73.7549V103.044L276.626 117.688L251.246 103.044V73.7549L276.626 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 59.1105L363.838 73.7549V103.044L338.458 117.688L313.078 103.044V73.7549L338.458 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 59.1105L425.67 73.7549V103.044L400.291 117.688L374.911 103.044V73.7549L400.291 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 59.1105L487.503 73.7549V103.044L462.123 117.688L436.743 103.044V73.7549L462.123 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 59.1105L549.335 73.7549V103.044L523.955 117.688L498.576 103.044V73.7549L523.955 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 59.1105L611.168 73.7549V103.044L585.788 117.688L560.408 103.044V73.7549L585.788 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 59.1105L673 73.7549V103.044L647.62 117.688L622.241 103.044V73.7549L647.62 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 165.323L54.6757 179.968V209.256L29.296 223.901L3.91625 209.256V179.968L29.296 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 165.323L116.508 179.968V209.256L91.1284 223.901L65.7487 209.256V179.968L91.1284 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 165.323L178.341 179.968V209.256L152.961 223.901L127.581 209.256V179.968L152.961 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 165.323L240.173 179.968V209.256L214.793 223.901L189.414 209.256V179.968L214.793 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 165.323L302.005 179.968V209.256L276.626 223.901L251.246 209.256V179.968L276.626 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 165.323L363.838 179.968V209.256L338.458 223.901L313.078 209.256V179.968L338.458 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 165.323L425.67 179.968V209.256L400.291 223.901L374.911 209.256V179.968L400.291 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 165.323L487.503 179.968V209.256L462.123 223.901L436.743 209.256V179.968L462.123 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 165.323L549.335 179.968V209.256L523.955 223.901L498.576 209.256V179.968L523.955 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 165.323L611.168 179.968V209.256L585.788 223.901L560.408 209.256V179.968L585.788 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 165.323L673 179.968V209.256L647.62 223.901L622.241 209.256V179.968L647.62 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 271.536L54.6757 286.18V315.469L29.296 330.113L3.91625 315.469V286.18L29.296 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 271.536L116.508 286.18V315.469L91.1284 330.113L65.7487 315.469V286.18L91.1284 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 271.536L178.341 286.18V315.469L152.961 330.113L127.581 315.469V286.18L152.961 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 271.536L240.173 286.18V315.469L214.793 330.113L189.414 315.469V286.18L214.793 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 271.536L302.005 286.18V315.469L276.626 330.113L251.246 315.469V286.18L276.626 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 271.536L363.838 286.18V315.469L338.458 330.113L313.078 315.469V286.18L338.458 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 271.536L425.67 286.18V315.469L400.291 330.113L374.911 315.469V286.18L400.291 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 271.536L487.503 286.18V315.469L462.123 330.113L436.743 315.469V286.18L462.123 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 271.536L549.335 286.18V315.469L523.955 330.113L498.576 315.469V286.18L523.955 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 271.536L611.168 286.18V315.469L585.788 330.113L560.408 315.469V286.18L585.788 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 271.536L673 286.18V315.469L647.62 330.113L622.241 315.469V286.18L647.62 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 377.748L54.6757 392.393V421.682L29.296 436.326L3.91625 421.682V392.393L29.296 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 377.748L116.508 392.393V421.682L91.1284 436.326L65.7487 421.682V392.393L91.1284 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 377.748L178.341 392.393V421.682L152.961 436.326L127.581 421.682V392.393L152.961 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 377.748L240.173 392.393V421.682L214.793 436.326L189.414 421.682V392.393L214.793 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 377.748L302.005 392.393V421.682L276.626 436.326L251.246 421.682V392.393L276.626 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 377.748L363.838 392.393V421.682L338.458 436.326L313.078 421.682V392.393L338.458 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 377.748L425.67 392.393V421.682L400.291 436.326L374.911 421.682V392.393L400.291 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 377.748L487.503 392.393V421.682L462.123 436.326L436.743 421.682V392.393L462.123 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 377.748L549.335 392.393V421.682L523.955 436.326L498.576 421.682V392.393L523.955 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 377.748L611.168 392.393V421.682L585.788 436.326L560.408 421.682V392.393L585.788 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 377.748L673 392.393V421.682L647.62 436.326L622.241 421.682V392.393L647.62 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62022 436.326L23.7595 450.971V480.26L-1.62022 494.904L-27 480.26V450.971L-1.62022 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 436.326L85.5919 450.971V480.26L60.2122 494.904L34.8325 480.26V450.971L60.2122 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 436.326L147.424 450.971V480.26L122.045 494.904L96.6649 480.26V450.971L122.045 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 436.326L209.257 450.971V480.26L183.877 494.904L158.497 480.26V450.971L183.877 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 436.326L271.089 450.971V480.26L245.709 494.904L220.33 480.26V450.971L245.709 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 436.326L332.922 450.971V480.26L307.542 494.904L282.162 480.26V450.971L307.542 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 436.326L394.754 450.971V480.26L369.374 494.904L343.995 480.26V450.971L369.374 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 436.326L456.586 450.971V480.26L431.207 494.904L405.827 480.26V450.971L431.207 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 436.326L518.419 450.971V480.26L493.039 494.904L467.659 480.26V450.971L493.039 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.872 436.326L580.251 450.971V480.26L554.872 494.904L529.492 480.26V450.971L554.872 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 436.326L642.084 450.971V480.26L616.704 494.904L591.324 480.26V450.971L616.704 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 542.539L23.7595 557.183V586.472L-1.62027 601.117L-27 586.472V557.183L-1.62027 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 542.539L85.5919 557.183V586.472L60.2122 601.117L34.8324 586.472V557.183L60.2122 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 542.539L147.424 557.183V586.472L122.045 601.117L96.6648 586.472V557.183L122.045 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 542.539L209.257 557.183V586.472L183.877 601.117L158.497 586.472V557.183L183.877 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 542.539L271.089 557.183V586.472L245.709 601.117L220.33 586.472V557.183L245.709 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 542.539L332.922 557.183V586.472L307.542 601.117L282.162 586.472V557.183L307.542 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 542.539L394.754 557.183V586.472L369.374 601.117L343.995 586.472V557.183L369.374 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 542.539L456.586 557.183V586.472L431.207 601.117L405.827 586.472V557.183L431.207 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 542.539L518.419 557.183V586.472L493.039 601.117L467.659 586.472V557.183L493.039 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 542.539L580.251 557.183V586.472L554.871 601.117L529.492 586.472V557.183L554.871 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 542.539L642.084 557.183V586.472L616.704 601.117L591.324 586.472V557.183L616.704 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 648.751L23.7595 663.396V692.685L-1.62027 707.329L-27 692.685V663.396L-1.62027 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 648.751L85.5919 663.396V692.685L60.2122 707.329L34.8324 692.685V663.396L60.2122 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 648.751L147.424 663.396V692.685L122.045 707.329L96.6648 692.685V663.396L122.045 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 648.751L209.257 663.396V692.685L183.877 707.329L158.497 692.685V663.396L183.877 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 648.751L271.089 663.396V692.685L245.709 707.329L220.33 692.685V663.396L245.709 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 648.751L332.922 663.396V692.685L307.542 707.329L282.162 692.685V663.396L307.542 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 648.751L394.754 663.396V692.685L369.374 707.329L343.995 692.685V663.396L369.374 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 648.751L456.586 663.396V692.685L431.207 707.329L405.827 692.685V663.396L431.207 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 648.751L518.419 663.396V692.685L493.039 707.329L467.659 692.685V663.396L493.039 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 648.751L580.251 663.396V692.685L554.871 707.329L529.492 692.685V663.396L554.871 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 648.751L642.084 663.396V692.685L616.704 707.329L591.324 692.685V663.396L616.704 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 754.964L23.7595 769.608V798.897L-1.62027 813.542L-27 798.897V769.608L-1.62027 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 754.964L85.5919 769.608V798.897L60.2122 813.542L34.8324 798.897V769.608L60.2122 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 754.964L147.424 769.608V798.897L122.045 813.542L96.6648 798.897V769.608L122.045 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 754.964L209.257 769.608V798.897L183.877 813.542L158.497 798.897V769.608L183.877 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 754.964L271.089 769.608V798.897L245.709 813.542L220.33 798.897V769.608L245.709 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 754.964L332.922 769.608V798.897L307.542 813.542L282.162 798.897V769.608L307.542 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 754.964L394.754 769.608V798.897L369.374 813.542L343.995 798.897V769.608L369.374 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 754.964L456.586 769.608V798.897L431.207 813.542L405.827 798.897V769.608L431.207 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 754.964L518.419 769.608V798.897L493.039 813.542L467.659 798.897V769.608L493.039 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 754.964L580.251 769.608V798.897L554.871 813.542L529.492 798.897V769.608L554.871 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 754.964L642.084 769.608V798.897L616.704 813.542L591.324 798.897V769.608L616.704 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 489.11L54.6757 503.755V533.044L29.296 547.688L3.91625 533.044V503.755L29.296 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 489.11L116.508 503.755V533.044L91.1284 547.688L65.7487 533.044V503.755L91.1284 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 489.11L178.341 503.755V533.044L152.961 547.688L127.581 533.044V503.755L152.961 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 489.11L240.173 503.755V533.044L214.793 547.688L189.414 533.044V503.755L214.793 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 489.11L302.005 503.755V533.044L276.626 547.688L251.246 533.044V503.755L276.626 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 489.11L363.838 503.755V533.044L338.458 547.688L313.078 533.044V503.755L338.458 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 489.11L425.67 503.755V533.044L400.291 547.688L374.911 533.044V503.755L400.291 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 489.11L487.503 503.755V533.044L462.123 547.688L436.743 533.044V503.755L462.123 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 489.11L549.335 503.755V533.044L523.955 547.688L498.576 533.044V503.755L523.955 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 489.11L611.168 503.755V533.044L585.788 547.688L560.408 533.044V503.755L585.788 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 489.11L673 503.755V533.044L647.62 547.688L622.241 533.044V503.755L647.62 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 595.323L54.6757 609.968V639.256L29.296 653.901L3.91625 639.256V609.968L29.296 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 595.323L116.508 609.968V639.256L91.1284 653.901L65.7487 639.256V609.968L91.1284 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 595.323L178.341 609.968V639.256L152.961 653.901L127.581 639.256V609.968L152.961 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 595.323L240.173 609.968V639.256L214.793 653.901L189.414 639.256V609.968L214.793 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 595.323L302.005 609.968V639.256L276.626 653.901L251.246 639.256V609.968L276.626 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 595.323L363.838 609.968V639.256L338.458 653.901L313.078 639.256V609.968L338.458 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 595.323L425.67 609.968V639.256L400.291 653.901L374.911 639.256V609.968L400.291 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 595.323L487.503 609.968V639.256L462.123 653.901L436.743 639.256V609.968L462.123 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 595.323L549.335 609.968V639.256L523.955 653.901L498.576 639.256V609.968L523.955 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 595.323L611.168 609.968V639.256L585.788 653.901L560.408 639.256V609.968L585.788 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 595.323L673 609.968V639.256L647.62 653.901L622.241 639.256V609.968L647.62 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 701.536L54.6757 716.18V745.469L29.296 760.114L3.91625 745.469V716.18L29.296 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 701.536L116.508 716.18V745.469L91.1284 760.114L65.7487 745.469V716.18L91.1284 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 701.536L178.341 716.18V745.469L152.961 760.114L127.581 745.469V716.18L152.961 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 701.536L240.173 716.18V745.469L214.793 760.114L189.414 745.469V716.18L214.793 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 701.536L302.005 716.18V745.469L276.626 760.114L251.246 745.469V716.18L276.626 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 701.536L363.838 716.18V745.469L338.458 760.114L313.078 745.469V716.18L338.458 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 701.536L425.67 716.18V745.469L400.291 760.114L374.911 745.469V716.18L400.291 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 701.536L487.503 716.18V745.469L462.123 760.114L436.743 745.469V716.18L462.123 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 701.536L549.335 716.18V745.469L523.955 760.114L498.576 745.469V716.18L523.955 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 701.536L611.168 716.18V745.469L585.788 760.114L560.408 745.469V716.18L585.788 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 701.536L673 716.18V745.469L647.62 760.114L622.241 745.469V716.18L647.62 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 807.748L54.6757 822.393V851.682L29.296 866.326L3.91625 851.682V822.393L29.296 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 807.748L116.508 822.393V851.682L91.1284 866.326L65.7487 851.682V822.393L91.1284 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 807.748L178.341 822.393V851.682L152.961 866.326L127.581 851.682V822.393L152.961 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 807.748L240.173 822.393V851.682L214.793 866.326L189.414 851.682V822.393L214.793 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 807.748L302.005 822.393V851.682L276.626 866.326L251.246 851.682V822.393L276.626 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 807.748L363.838 822.393V851.682L338.458 866.326L313.078 851.682V822.393L338.458 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 807.748L425.67 822.393V851.682L400.291 866.326L374.911 851.682V822.393L400.291 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 807.748L487.503 822.393V851.682L462.123 866.326L436.743 851.682V822.393L462.123 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 807.748L549.335 822.393V851.682L523.955 866.326L498.576 851.682V822.393L523.955 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 807.748L611.168 822.393V851.682L585.788 866.326L560.408 851.682V822.393L585.788 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 807.748L673 822.393V851.682L647.62 866.326L622.241 851.682V822.393L647.62 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 6.32617L702.76 20.9706V50.2595L677.38 64.904L652 50.2595V20.9706L677.38 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 6.32617L764.592 20.9706V50.2595L739.212 64.904L713.832 50.2595V20.9706L739.212 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 6.32617L826.424 20.9706V50.2595L801.045 64.904L775.665 50.2595V20.9706L801.045 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 6.32617L888.257 20.9706V50.2595L862.877 64.904L837.497 50.2595V20.9706L862.877 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 6.32617L950.089 20.9706V50.2595L924.709 64.904L899.33 50.2595V20.9706L924.709 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 6.32617L1011.92 20.9706V50.2595L986.542 64.904L961.162 50.2595V20.9706L986.542 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 6.32617L1073.75 20.9706V50.2595L1048.37 64.904L1022.99 50.2595V20.9706L1048.37 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 6.32617L1135.59 20.9706V50.2595L1110.21 64.904L1084.83 50.2595V20.9706L1110.21 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 6.32617L1197.42 20.9706V50.2595L1172.04 64.904L1146.66 50.2595V20.9706L1172.04 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 6.32617L1259.25 20.9706V50.2595L1233.87 64.904L1208.49 50.2595V20.9706L1233.87 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 6.32617L1321.08 20.9706V50.2595L1295.7 64.904L1270.32 50.2595V20.9706L1295.7 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 112.539L702.759 127.183V156.472L677.38 171.117L652 156.472V127.183L677.38 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 112.539L764.592 127.183V156.472L739.212 171.117L713.832 156.472V127.183L739.212 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 112.539L826.424 127.183V156.472L801.045 171.117L775.665 156.472V127.183L801.045 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 112.539L888.257 127.183V156.472L862.877 171.117L837.497 156.472V127.183L862.877 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 112.539L950.089 127.183V156.472L924.709 171.117L899.33 156.472V127.183L924.709 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 112.539L1011.92 127.183V156.472L986.542 171.117L961.162 156.472V127.183L986.542 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 112.539L1073.75 127.183V156.472L1048.37 171.117L1022.99 156.472V127.183L1048.37 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 112.539L1135.59 127.183V156.472L1110.21 171.117L1084.83 156.472V127.183L1110.21 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 112.539L1197.42 127.183V156.472L1172.04 171.117L1146.66 156.472V127.183L1172.04 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 112.539L1259.25 127.183V156.472L1233.87 171.117L1208.49 156.472V127.183L1233.87 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 112.539L1321.08 127.183V156.472L1295.7 171.117L1270.32 156.472V127.183L1295.7 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 218.751L702.759 233.396V262.685L677.38 277.329L652 262.685V233.396L677.38 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 218.751L764.592 233.396V262.685L739.212 277.329L713.832 262.685V233.396L739.212 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 218.751L826.424 233.396V262.685L801.045 277.329L775.665 262.685V233.396L801.045 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 218.751L888.257 233.396V262.685L862.877 277.329L837.497 262.685V233.396L862.877 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 218.751L950.089 233.396V262.685L924.709 277.329L899.33 262.685V233.396L924.709 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 218.751L1011.92 233.396V262.685L986.542 277.329L961.162 262.685V233.396L986.542 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 218.751L1073.75 233.396V262.685L1048.37 277.329L1022.99 262.685V233.396L1048.37 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 218.751L1135.59 233.396V262.685L1110.21 277.329L1084.83 262.685V233.396L1110.21 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 218.751L1197.42 233.396V262.685L1172.04 277.329L1146.66 262.685V233.396L1172.04 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 218.751L1259.25 233.396V262.685L1233.87 277.329L1208.49 262.685V233.396L1233.87 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 218.751L1321.08 233.396V262.685L1295.7 277.329L1270.32 262.685V233.396L1295.7 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 324.964L702.759 339.608V368.897L677.38 383.542L652 368.897V339.608L677.38 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 324.964L764.592 339.608V368.897L739.212 383.542L713.832 368.897V339.608L739.212 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 324.964L826.424 339.608V368.897L801.045 383.542L775.665 368.897V339.608L801.045 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 324.964L888.257 339.608V368.897L862.877 383.542L837.497 368.897V339.608L862.877 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 324.964L950.089 339.608V368.897L924.709 383.542L899.33 368.897V339.608L924.709 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 324.964L1011.92 339.608V368.897L986.542 383.542L961.162 368.897V339.608L986.542 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 324.964L1073.75 339.608V368.897L1048.37 383.542L1022.99 368.897V339.608L1048.37 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 324.964L1135.59 339.608V368.897L1110.21 383.542L1084.83 368.897V339.608L1110.21 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 324.964L1197.42 339.608V368.897L1172.04 383.542L1146.66 368.897V339.608L1172.04 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 324.964L1259.25 339.608V368.897L1233.87 383.542L1208.49 368.897V339.608L1233.87 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 324.964L1321.08 339.608V368.897L1295.7 383.542L1270.32 368.897V339.608L1295.7 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 59.1105L733.676 73.7549V103.044L708.296 117.688L682.916 103.044V73.7549L708.296 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 59.1105L795.508 73.7549V103.044L770.128 117.688L744.749 103.044V73.7549L770.128 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 59.1105L857.341 73.7549V103.044L831.961 117.688L806.581 103.044V73.7549L831.961 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 59.1105L919.173 73.7549V103.044L893.793 117.688L868.414 103.044V73.7549L893.793 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 59.1105L981.005 73.7549V103.044L955.626 117.688L930.246 103.044V73.7549L955.626 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 59.1105L1042.84 73.7549V103.044L1017.46 117.688L992.078 103.044V73.7549L1017.46 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 59.1105L1104.67 73.7549V103.044L1079.29 117.688L1053.91 103.044V73.7549L1079.29 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 59.1105L1166.5 73.7549V103.044L1141.12 117.688L1115.74 103.044V73.7549L1141.12 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 59.1105L1228.34 73.7549V103.044L1202.96 117.688L1177.58 103.044V73.7549L1202.96 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 59.1105L1290.17 73.7549V103.044L1264.79 117.688L1239.41 103.044V73.7549L1264.79 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 59.1105L1352 73.7549V103.044L1326.62 117.688L1301.24 103.044V73.7549L1326.62 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 165.323L733.676 179.968V209.256L708.296 223.901L682.916 209.256V179.968L708.296 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 165.323L795.508 179.968V209.256L770.128 223.901L744.749 209.256V179.968L770.128 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 165.323L857.341 179.968V209.256L831.961 223.901L806.581 209.256V179.968L831.961 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 165.323L919.173 179.968V209.256L893.793 223.901L868.414 209.256V179.968L893.793 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 165.323L981.005 179.968V209.256L955.626 223.901L930.246 209.256V179.968L955.626 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 165.323L1042.84 179.968V209.256L1017.46 223.901L992.078 209.256V179.968L1017.46 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 165.323L1104.67 179.968V209.256L1079.29 223.901L1053.91 209.256V179.968L1079.29 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 165.323L1166.5 179.968V209.256L1141.12 223.901L1115.74 209.256V179.968L1141.12 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 165.323L1228.34 179.968V209.256L1202.96 223.901L1177.58 209.256V179.968L1202.96 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 165.323L1290.17 179.968V209.256L1264.79 223.901L1239.41 209.256V179.968L1264.79 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 165.323L1352 179.968V209.256L1326.62 223.901L1301.24 209.256V179.968L1326.62 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 271.536L733.676 286.18V315.469L708.296 330.113L682.916 315.469V286.18L708.296 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 271.536L795.508 286.18V315.469L770.128 330.113L744.749 315.469V286.18L770.128 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 271.536L857.341 286.18V315.469L831.961 330.113L806.581 315.469V286.18L831.961 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 271.536L919.173 286.18V315.469L893.793 330.113L868.414 315.469V286.18L893.793 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 271.536L981.005 286.18V315.469L955.626 330.113L930.246 315.469V286.18L955.626 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 271.536L1042.84 286.18V315.469L1017.46 330.113L992.078 315.469V286.18L1017.46 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 271.536L1104.67 286.18V315.469L1079.29 330.113L1053.91 315.469V286.18L1079.29 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 271.536L1166.5 286.18V315.469L1141.12 330.113L1115.74 315.469V286.18L1141.12 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 271.536L1228.34 286.18V315.469L1202.96 330.113L1177.58 315.469V286.18L1202.96 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 271.536L1290.17 286.18V315.469L1264.79 330.113L1239.41 315.469V286.18L1264.79 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 271.536L1352 286.18V315.469L1326.62 330.113L1301.24 315.469V286.18L1326.62 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 377.748L733.676 392.393V421.682L708.296 436.326L682.916 421.682V392.393L708.296 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 377.748L795.508 392.393V421.682L770.128 436.326L744.749 421.682V392.393L770.128 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 377.748L857.341 392.393V421.682L831.961 436.326L806.581 421.682V392.393L831.961 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 377.748L919.173 392.393V421.682L893.793 436.326L868.414 421.682V392.393L893.793 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 377.748L981.005 392.393V421.682L955.626 436.326L930.246 421.682V392.393L955.626 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 377.748L1042.84 392.393V421.682L1017.46 436.326L992.078 421.682V392.393L1017.46 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 377.748L1104.67 392.393V421.682L1079.29 436.326L1053.91 421.682V392.393L1079.29 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 377.748L1166.5 392.393V421.682L1141.12 436.326L1115.74 421.682V392.393L1141.12 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 377.748L1228.34 392.393V421.682L1202.96 436.326L1177.58 421.682V392.393L1202.96 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 377.748L1290.17 392.393V421.682L1264.79 436.326L1239.41 421.682V392.393L1264.79 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 377.748L1352 392.393V421.682L1326.62 436.326L1301.24 421.682V392.393L1326.62 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 436.326L702.76 450.971V480.26L677.38 494.904L652 480.26V450.971L677.38 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 436.326L764.592 450.971V480.26L739.212 494.904L713.832 480.26V450.971L739.212 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 436.326L826.424 450.971V480.26L801.045 494.904L775.665 480.26V450.971L801.045 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 436.326L888.257 450.971V480.26L862.877 494.904L837.497 480.26V450.971L862.877 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 436.326L950.089 450.971V480.26L924.709 494.904L899.33 480.26V450.971L924.709 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 436.326L1011.92 450.971V480.26L986.542 494.904L961.162 480.26V450.971L986.542 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 436.326L1073.75 450.971V480.26L1048.37 494.904L1022.99 480.26V450.971L1048.37 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 436.326L1135.59 450.971V480.26L1110.21 494.904L1084.83 480.26V450.971L1110.21 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 436.326L1197.42 450.971V480.26L1172.04 494.904L1146.66 480.26V450.971L1172.04 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 436.326L1259.25 450.971V480.26L1233.87 494.904L1208.49 480.26V450.971L1233.87 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 436.326L1321.08 450.971V480.26L1295.7 494.904L1270.32 480.26V450.971L1295.7 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 542.539L702.759 557.183V586.472L677.38 601.117L652 586.472V557.183L677.38 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 542.539L764.592 557.183V586.472L739.212 601.117L713.832 586.472V557.183L739.212 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 542.539L826.424 557.183V586.472L801.045 601.117L775.665 586.472V557.183L801.045 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 542.539L888.257 557.183V586.472L862.877 601.117L837.497 586.472V557.183L862.877 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 542.539L950.089 557.183V586.472L924.709 601.117L899.33 586.472V557.183L924.709 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 542.539L1011.92 557.183V586.472L986.542 601.117L961.162 586.472V557.183L986.542 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 542.539L1073.75 557.183V586.472L1048.37 601.117L1022.99 586.472V557.183L1048.37 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 542.539L1135.59 557.183V586.472L1110.21 601.117L1084.83 586.472V557.183L1110.21 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 542.539L1197.42 557.183V586.472L1172.04 601.117L1146.66 586.472V557.183L1172.04 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 542.539L1259.25 557.183V586.472L1233.87 601.117L1208.49 586.472V557.183L1233.87 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 542.539L1321.08 557.183V586.472L1295.7 601.117L1270.32 586.472V557.183L1295.7 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 648.751L702.759 663.396V692.685L677.38 707.329L652 692.685V663.396L677.38 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 648.751L764.592 663.396V692.685L739.212 707.329L713.832 692.685V663.396L739.212 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 648.751L826.424 663.396V692.685L801.045 707.329L775.665 692.685V663.396L801.045 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 648.751L888.257 663.396V692.685L862.877 707.329L837.497 692.685V663.396L862.877 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 648.751L950.089 663.396V692.685L924.709 707.329L899.33 692.685V663.396L924.709 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 648.751L1011.92 663.396V692.685L986.542 707.329L961.162 692.685V663.396L986.542 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 648.751L1073.75 663.396V692.685L1048.37 707.329L1022.99 692.685V663.396L1048.37 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 648.751L1135.59 663.396V692.685L1110.21 707.329L1084.83 692.685V663.396L1110.21 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 648.751L1197.42 663.396V692.685L1172.04 707.329L1146.66 692.685V663.396L1172.04 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 648.751L1259.25 663.396V692.685L1233.87 707.329L1208.49 692.685V663.396L1233.87 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 648.751L1321.08 663.396V692.685L1295.7 707.329L1270.32 692.685V663.396L1295.7 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 754.964L702.759 769.608V798.897L677.38 813.542L652 798.897V769.608L677.38 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 754.964L764.592 769.608V798.897L739.212 813.542L713.832 798.897V769.608L739.212 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 754.964L826.424 769.608V798.897L801.045 813.542L775.665 798.897V769.608L801.045 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 754.964L888.257 769.608V798.897L862.877 813.542L837.497 798.897V769.608L862.877 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 754.964L950.089 769.608V798.897L924.709 813.542L899.33 798.897V769.608L924.709 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 754.964L1011.92 769.608V798.897L986.542 813.542L961.162 798.897V769.608L986.542 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 754.964L1073.75 769.608V798.897L1048.37 813.542L1022.99 798.897V769.608L1048.37 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 754.964L1135.59 769.608V798.897L1110.21 813.542L1084.83 798.897V769.608L1110.21 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 754.964L1197.42 769.608V798.897L1172.04 813.542L1146.66 798.897V769.608L1172.04 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 754.964L1259.25 769.608V798.897L1233.87 813.542L1208.49 798.897V769.608L1233.87 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 754.964L1321.08 769.608V798.897L1295.7 813.542L1270.32 798.897V769.608L1295.7 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 489.11L733.676 503.755V533.044L708.296 547.688L682.916 533.044V503.755L708.296 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 489.11L795.508 503.755V533.044L770.128 547.688L744.749 533.044V503.755L770.128 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 489.11L857.341 503.755V533.044L831.961 547.688L806.581 533.044V503.755L831.961 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 489.11L919.173 503.755V533.044L893.793 547.688L868.414 533.044V503.755L893.793 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 489.11L981.005 503.755V533.044L955.626 547.688L930.246 533.044V503.755L955.626 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 489.11L1042.84 503.755V533.044L1017.46 547.688L992.078 533.044V503.755L1017.46 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 489.11L1104.67 503.755V533.044L1079.29 547.688L1053.91 533.044V503.755L1079.29 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 489.11L1166.5 503.755V533.044L1141.12 547.688L1115.74 533.044V503.755L1141.12 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 489.11L1228.34 503.755V533.044L1202.96 547.688L1177.58 533.044V503.755L1202.96 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 489.11L1290.17 503.755V533.044L1264.79 547.688L1239.41 533.044V503.755L1264.79 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 489.11L1352 503.755V533.044L1326.62 547.688L1301.24 533.044V503.755L1326.62 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 595.323L733.676 609.968V639.256L708.296 653.901L682.916 639.256V609.968L708.296 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 595.323L795.508 609.968V639.256L770.128 653.901L744.749 639.256V609.968L770.128 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 595.323L857.341 609.968V639.256L831.961 653.901L806.581 639.256V609.968L831.961 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 595.323L919.173 609.968V639.256L893.793 653.901L868.414 639.256V609.968L893.793 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 595.323L981.005 609.968V639.256L955.626 653.901L930.246 639.256V609.968L955.626 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 595.323L1042.84 609.968V639.256L1017.46 653.901L992.078 639.256V609.968L1017.46 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 595.323L1104.67 609.968V639.256L1079.29 653.901L1053.91 639.256V609.968L1079.29 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 595.323L1166.5 609.968V639.256L1141.12 653.901L1115.74 639.256V609.968L1141.12 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 595.323L1228.34 609.968V639.256L1202.96 653.901L1177.58 639.256V609.968L1202.96 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 595.323L1290.17 609.968V639.256L1264.79 653.901L1239.41 639.256V609.968L1264.79 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 595.323L1352 609.968V639.256L1326.62 653.901L1301.24 639.256V609.968L1326.62 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 701.536L733.676 716.18V745.469L708.296 760.114L682.916 745.469V716.18L708.296 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 701.536L795.508 716.18V745.469L770.128 760.114L744.749 745.469V716.18L770.128 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 701.536L857.341 716.18V745.469L831.961 760.114L806.581 745.469V716.18L831.961 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 701.536L919.173 716.18V745.469L893.793 760.114L868.414 745.469V716.18L893.793 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 701.536L981.005 716.18V745.469L955.626 760.114L930.246 745.469V716.18L955.626 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 701.536L1042.84 716.18V745.469L1017.46 760.114L992.078 745.469V716.18L1017.46 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 701.536L1104.67 716.18V745.469L1079.29 760.114L1053.91 745.469V716.18L1079.29 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 701.536L1166.5 716.18V745.469L1141.12 760.114L1115.74 745.469V716.18L1141.12 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 701.536L1228.34 716.18V745.469L1202.96 760.114L1177.58 745.469V716.18L1202.96 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 701.536L1290.17 716.18V745.469L1264.79 760.114L1239.41 745.469V716.18L1264.79 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 701.536L1352 716.18V745.469L1326.62 760.114L1301.24 745.469V716.18L1326.62 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 807.748L733.676 822.393V851.682L708.296 866.326L682.916 851.682V822.393L708.296 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 807.748L795.508 822.393V851.682L770.128 866.326L744.749 851.682V822.393L770.128 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 807.748L857.341 822.393V851.682L831.961 866.326L806.581 851.682V822.393L831.961 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 807.748L919.173 822.393V851.682L893.793 866.326L868.414 851.682V822.393L893.793 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 807.748L981.005 822.393V851.682L955.626 866.326L930.246 851.682V822.393L955.626 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 807.748L1042.84 822.393V851.682L1017.46 866.326L992.078 851.682V822.393L1017.46 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 807.748L1104.67 822.393V851.682L1079.29 866.326L1053.91 851.682V822.393L1079.29 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 807.748L1166.5 822.393V851.682L1141.12 866.326L1115.74 851.682V822.393L1141.12 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 807.748L1228.34 822.393V851.682L1202.96 866.326L1177.58 851.682V822.393L1202.96 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 807.748L1290.17 822.393V851.682L1264.79 866.326L1239.41 851.682V822.393L1264.79 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 807.748L1352 822.393V851.682L1326.62 866.326L1301.24 851.682V822.393L1326.62 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 6.32617L1381.76 20.9706V50.2595L1356.38 64.904L1331 50.2595V20.9706L1356.38 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 6.32617L1443.59 20.9706V50.2595L1418.21 64.904L1392.83 50.2595V20.9706L1418.21 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 6.32617L1505.42 20.9706V50.2595L1480.04 64.904L1454.66 50.2595V20.9706L1480.04 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 6.32617L1567.26 20.9706V50.2595L1541.88 64.904L1516.5 50.2595V20.9706L1541.88 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 6.32617L1629.09 20.9706V50.2595L1603.71 64.904L1578.33 50.2595V20.9706L1603.71 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 6.32617L1690.92 20.9706V50.2595L1665.54 64.904L1640.16 50.2595V20.9706L1665.54 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 6.32617L1752.75 20.9706V50.2595L1727.37 64.904L1701.99 50.2595V20.9706L1727.37 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 6.32617L1814.59 20.9706V50.2595L1789.21 64.904L1763.83 50.2595V20.9706L1789.21 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 6.32617L1876.42 20.9706V50.2595L1851.04 64.904L1825.66 50.2595V20.9706L1851.04 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 6.32617L1938.25 20.9706V50.2595L1912.87 64.904L1887.49 50.2595V20.9706L1912.87 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 6.32617L2000.08 20.9706V50.2595L1974.7 64.904L1949.32 50.2595V20.9706L1974.7 6.32617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 112.539L1381.76 127.183V156.472L1356.38 171.117L1331 156.472V127.183L1356.38 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 112.539L1443.59 127.183V156.472L1418.21 171.117L1392.83 156.472V127.183L1418.21 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 112.539L1505.42 127.183V156.472L1480.04 171.117L1454.66 156.472V127.183L1480.04 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 112.539L1567.26 127.183V156.472L1541.88 171.117L1516.5 156.472V127.183L1541.88 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 112.539L1629.09 127.183V156.472L1603.71 171.117L1578.33 156.472V127.183L1603.71 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 112.539L1690.92 127.183V156.472L1665.54 171.117L1640.16 156.472V127.183L1665.54 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 112.539L1752.75 127.183V156.472L1727.37 171.117L1701.99 156.472V127.183L1727.37 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 112.539L1814.59 127.183V156.472L1789.21 171.117L1763.83 156.472V127.183L1789.21 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 112.539L1876.42 127.183V156.472L1851.04 171.117L1825.66 156.472V127.183L1851.04 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 112.539L1938.25 127.183V156.472L1912.87 171.117L1887.49 156.472V127.183L1912.87 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 112.539L2000.08 127.183V156.472L1974.7 171.117L1949.32 156.472V127.183L1974.7 112.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 218.751L1381.76 233.396V262.685L1356.38 277.329L1331 262.685V233.396L1356.38 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 218.751L1443.59 233.396V262.685L1418.21 277.329L1392.83 262.685V233.396L1418.21 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 218.751L1505.42 233.396V262.685L1480.04 277.329L1454.66 262.685V233.396L1480.04 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 218.751L1567.26 233.396V262.685L1541.88 277.329L1516.5 262.685V233.396L1541.88 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 218.751L1629.09 233.396V262.685L1603.71 277.329L1578.33 262.685V233.396L1603.71 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 218.751L1690.92 233.396V262.685L1665.54 277.329L1640.16 262.685V233.396L1665.54 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 218.751L1752.75 233.396V262.685L1727.37 277.329L1701.99 262.685V233.396L1727.37 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 218.751L1814.59 233.396V262.685L1789.21 277.329L1763.83 262.685V233.396L1789.21 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 218.751L1876.42 233.396V262.685L1851.04 277.329L1825.66 262.685V233.396L1851.04 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 218.751L1938.25 233.396V262.685L1912.87 277.329L1887.49 262.685V233.396L1912.87 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 218.751L2000.08 233.396V262.685L1974.7 277.329L1949.32 262.685V233.396L1974.7 218.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 324.964L1381.76 339.608V368.897L1356.38 383.542L1331 368.897V339.608L1356.38 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 324.964L1443.59 339.608V368.897L1418.21 383.542L1392.83 368.897V339.608L1418.21 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 324.964L1505.42 339.608V368.897L1480.04 383.542L1454.66 368.897V339.608L1480.04 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 324.964L1567.26 339.608V368.897L1541.88 383.542L1516.5 368.897V339.608L1541.88 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 324.964L1629.09 339.608V368.897L1603.71 383.542L1578.33 368.897V339.608L1603.71 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 324.964L1690.92 339.608V368.897L1665.54 383.542L1640.16 368.897V339.608L1665.54 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 324.964L1752.75 339.608V368.897L1727.37 383.542L1701.99 368.897V339.608L1727.37 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 324.964L1814.59 339.608V368.897L1789.21 383.542L1763.83 368.897V339.608L1789.21 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 324.964L1876.42 339.608V368.897L1851.04 383.542L1825.66 368.897V339.608L1851.04 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 324.964L1938.25 339.608V368.897L1912.87 383.542L1887.49 368.897V339.608L1912.87 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 324.964L2000.08 339.608V368.897L1974.7 383.542L1949.32 368.897V339.608L1974.7 324.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 59.1105L1412.68 73.7549V103.044L1387.3 117.688L1361.92 103.044V73.7549L1387.3 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 59.1105L1474.51 73.7549V103.044L1449.13 117.688L1423.75 103.044V73.7549L1449.13 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 59.1105L1536.34 73.7549V103.044L1510.96 117.688L1485.58 103.044V73.7549L1510.96 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 59.1105L1598.17 73.7549V103.044L1572.79 117.688L1547.41 103.044V73.7549L1572.79 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 59.1105L1660.01 73.7549V103.044L1634.63 117.688L1609.25 103.044V73.7549L1634.63 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 59.1105L1721.84 73.7549V103.044L1696.46 117.688L1671.08 103.044V73.7549L1696.46 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 59.1105L1783.67 73.7549V103.044L1758.29 117.688L1732.91 103.044V73.7549L1758.29 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 59.1105L1845.5 73.7549V103.044L1820.12 117.688L1794.74 103.044V73.7549L1820.12 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 59.1105L1907.34 73.7549V103.044L1881.96 117.688L1856.58 103.044V73.7549L1881.96 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 59.1105L1969.17 73.7549V103.044L1943.79 117.688L1918.41 103.044V73.7549L1943.79 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 59.1105L2031 73.7549V103.044L2005.62 117.688L1980.24 103.044V73.7549L2005.62 59.1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 165.323L1412.68 179.968V209.256L1387.3 223.901L1361.92 209.256V179.968L1387.3 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 165.323L1474.51 179.968V209.256L1449.13 223.901L1423.75 209.256V179.968L1449.13 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 165.323L1536.34 179.968V209.256L1510.96 223.901L1485.58 209.256V179.968L1510.96 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 165.323L1598.17 179.968V209.256L1572.79 223.901L1547.41 209.256V179.968L1572.79 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 165.323L1660.01 179.968V209.256L1634.63 223.901L1609.25 209.256V179.968L1634.63 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 165.323L1721.84 179.968V209.256L1696.46 223.901L1671.08 209.256V179.968L1696.46 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 165.323L1783.67 179.968V209.256L1758.29 223.901L1732.91 209.256V179.968L1758.29 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 165.323L1845.5 179.968V209.256L1820.12 223.901L1794.74 209.256V179.968L1820.12 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 165.323L1907.34 179.968V209.256L1881.96 223.901L1856.58 209.256V179.968L1881.96 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 165.323L1969.17 179.968V209.256L1943.79 223.901L1918.41 209.256V179.968L1943.79 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 165.323L2031 179.968V209.256L2005.62 223.901L1980.24 209.256V179.968L2005.62 165.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 271.536L1412.68 286.18V315.469L1387.3 330.113L1361.92 315.469V286.18L1387.3 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 271.536L1474.51 286.18V315.469L1449.13 330.113L1423.75 315.469V286.18L1449.13 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 271.536L1536.34 286.18V315.469L1510.96 330.113L1485.58 315.469V286.18L1510.96 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 271.536L1598.17 286.18V315.469L1572.79 330.113L1547.41 315.469V286.18L1572.79 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 271.536L1660.01 286.18V315.469L1634.63 330.113L1609.25 315.469V286.18L1634.63 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 271.536L1721.84 286.18V315.469L1696.46 330.113L1671.08 315.469V286.18L1696.46 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 271.536L1783.67 286.18V315.469L1758.29 330.113L1732.91 315.469V286.18L1758.29 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 271.536L1845.5 286.18V315.469L1820.12 330.113L1794.74 315.469V286.18L1820.12 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 271.536L1907.34 286.18V315.469L1881.96 330.113L1856.58 315.469V286.18L1881.96 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 271.536L1969.17 286.18V315.469L1943.79 330.113L1918.41 315.469V286.18L1943.79 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 271.536L2031 286.18V315.469L2005.62 330.113L1980.24 315.469V286.18L2005.62 271.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 377.748L1412.68 392.393V421.682L1387.3 436.326L1361.92 421.682V392.393L1387.3 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 377.748L1474.51 392.393V421.682L1449.13 436.326L1423.75 421.682V392.393L1449.13 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 377.748L1536.34 392.393V421.682L1510.96 436.326L1485.58 421.682V392.393L1510.96 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 377.748L1598.17 392.393V421.682L1572.79 436.326L1547.41 421.682V392.393L1572.79 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 377.748L1660.01 392.393V421.682L1634.63 436.326L1609.25 421.682V392.393L1634.63 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 377.748L1721.84 392.393V421.682L1696.46 436.326L1671.08 421.682V392.393L1696.46 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 377.748L1783.67 392.393V421.682L1758.29 436.326L1732.91 421.682V392.393L1758.29 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 377.748L1845.5 392.393V421.682L1820.12 436.326L1794.74 421.682V392.393L1820.12 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 377.748L1907.34 392.393V421.682L1881.96 436.326L1856.58 421.682V392.393L1881.96 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 377.748L1969.17 392.393V421.682L1943.79 436.326L1918.41 421.682V392.393L1943.79 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 377.748L2031 392.393V421.682L2005.62 436.326L1980.24 421.682V392.393L2005.62 377.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 436.326L1381.76 450.971V480.26L1356.38 494.904L1331 480.26V450.971L1356.38 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 436.326L1443.59 450.971V480.26L1418.21 494.904L1392.83 480.26V450.971L1418.21 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 436.326L1505.42 450.971V480.26L1480.04 494.904L1454.66 480.26V450.971L1480.04 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 436.326L1567.26 450.971V480.26L1541.88 494.904L1516.5 480.26V450.971L1541.88 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 436.326L1629.09 450.971V480.26L1603.71 494.904L1578.33 480.26V450.971L1603.71 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 436.326L1690.92 450.971V480.26L1665.54 494.904L1640.16 480.26V450.971L1665.54 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 436.326L1752.75 450.971V480.26L1727.37 494.904L1701.99 480.26V450.971L1727.37 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 436.326L1814.59 450.971V480.26L1789.21 494.904L1763.83 480.26V450.971L1789.21 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 436.326L1876.42 450.971V480.26L1851.04 494.904L1825.66 480.26V450.971L1851.04 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 436.326L1938.25 450.971V480.26L1912.87 494.904L1887.49 480.26V450.971L1912.87 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 436.326L2000.08 450.971V480.26L1974.7 494.904L1949.32 480.26V450.971L1974.7 436.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 542.539L1381.76 557.183V586.472L1356.38 601.117L1331 586.472V557.183L1356.38 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 542.539L1443.59 557.183V586.472L1418.21 601.117L1392.83 586.472V557.183L1418.21 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 542.539L1505.42 557.183V586.472L1480.04 601.117L1454.66 586.472V557.183L1480.04 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 542.539L1567.26 557.183V586.472L1541.88 601.117L1516.5 586.472V557.183L1541.88 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 542.539L1629.09 557.183V586.472L1603.71 601.117L1578.33 586.472V557.183L1603.71 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 542.539L1690.92 557.183V586.472L1665.54 601.117L1640.16 586.472V557.183L1665.54 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 542.539L1752.75 557.183V586.472L1727.37 601.117L1701.99 586.472V557.183L1727.37 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 542.539L1814.59 557.183V586.472L1789.21 601.117L1763.83 586.472V557.183L1789.21 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 542.539L1876.42 557.183V586.472L1851.04 601.117L1825.66 586.472V557.183L1851.04 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 542.539L1938.25 557.183V586.472L1912.87 601.117L1887.49 586.472V557.183L1912.87 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 542.539L2000.08 557.183V586.472L1974.7 601.117L1949.32 586.472V557.183L1974.7 542.539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 648.751L1381.76 663.396V692.685L1356.38 707.329L1331 692.685V663.396L1356.38 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 648.751L1443.59 663.396V692.685L1418.21 707.329L1392.83 692.685V663.396L1418.21 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 648.751L1505.42 663.396V692.685L1480.04 707.329L1454.66 692.685V663.396L1480.04 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 648.751L1567.26 663.396V692.685L1541.88 707.329L1516.5 692.685V663.396L1541.88 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 648.751L1629.09 663.396V692.685L1603.71 707.329L1578.33 692.685V663.396L1603.71 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 648.751L1690.92 663.396V692.685L1665.54 707.329L1640.16 692.685V663.396L1665.54 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 648.751L1752.75 663.396V692.685L1727.37 707.329L1701.99 692.685V663.396L1727.37 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 648.751L1814.59 663.396V692.685L1789.21 707.329L1763.83 692.685V663.396L1789.21 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 648.751L1876.42 663.396V692.685L1851.04 707.329L1825.66 692.685V663.396L1851.04 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 648.751L1938.25 663.396V692.685L1912.87 707.329L1887.49 692.685V663.396L1912.87 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 648.751L2000.08 663.396V692.685L1974.7 707.329L1949.32 692.685V663.396L1974.7 648.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 754.964L1381.76 769.608V798.897L1356.38 813.542L1331 798.897V769.608L1356.38 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 754.964L1443.59 769.608V798.897L1418.21 813.542L1392.83 798.897V769.608L1418.21 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 754.964L1505.42 769.608V798.897L1480.04 813.542L1454.66 798.897V769.608L1480.04 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 754.964L1567.26 769.608V798.897L1541.88 813.542L1516.5 798.897V769.608L1541.88 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 754.964L1629.09 769.608V798.897L1603.71 813.542L1578.33 798.897V769.608L1603.71 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 754.964L1690.92 769.608V798.897L1665.54 813.542L1640.16 798.897V769.608L1665.54 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 754.964L1752.75 769.608V798.897L1727.37 813.542L1701.99 798.897V769.608L1727.37 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 754.964L1814.59 769.608V798.897L1789.21 813.542L1763.83 798.897V769.608L1789.21 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 754.964L1876.42 769.608V798.897L1851.04 813.542L1825.66 798.897V769.608L1851.04 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 754.964L1938.25 769.608V798.897L1912.87 813.542L1887.49 798.897V769.608L1912.87 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 754.964L2000.08 769.608V798.897L1974.7 813.542L1949.32 798.897V769.608L1974.7 754.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 489.11L1412.68 503.755V533.044L1387.3 547.688L1361.92 533.044V503.755L1387.3 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 489.11L1474.51 503.755V533.044L1449.13 547.688L1423.75 533.044V503.755L1449.13 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 489.11L1536.34 503.755V533.044L1510.96 547.688L1485.58 533.044V503.755L1510.96 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 489.11L1598.17 503.755V533.044L1572.79 547.688L1547.41 533.044V503.755L1572.79 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 489.11L1660.01 503.755V533.044L1634.63 547.688L1609.25 533.044V503.755L1634.63 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 489.11L1721.84 503.755V533.044L1696.46 547.688L1671.08 533.044V503.755L1696.46 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 489.11L1783.67 503.755V533.044L1758.29 547.688L1732.91 533.044V503.755L1758.29 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 489.11L1845.5 503.755V533.044L1820.12 547.688L1794.74 533.044V503.755L1820.12 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 489.11L1907.34 503.755V533.044L1881.96 547.688L1856.58 533.044V503.755L1881.96 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 489.11L1969.17 503.755V533.044L1943.79 547.688L1918.41 533.044V503.755L1943.79 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 489.11L2031 503.755V533.044L2005.62 547.688L1980.24 533.044V503.755L2005.62 489.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 595.323L1412.68 609.968V639.256L1387.3 653.901L1361.92 639.256V609.968L1387.3 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 595.323L1474.51 609.968V639.256L1449.13 653.901L1423.75 639.256V609.968L1449.13 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 595.323L1536.34 609.968V639.256L1510.96 653.901L1485.58 639.256V609.968L1510.96 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 595.323L1598.17 609.968V639.256L1572.79 653.901L1547.41 639.256V609.968L1572.79 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 595.323L1660.01 609.968V639.256L1634.63 653.901L1609.25 639.256V609.968L1634.63 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 595.323L1721.84 609.968V639.256L1696.46 653.901L1671.08 639.256V609.968L1696.46 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 595.323L1783.67 609.968V639.256L1758.29 653.901L1732.91 639.256V609.968L1758.29 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 595.323L1845.5 609.968V639.256L1820.12 653.901L1794.74 639.256V609.968L1820.12 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 595.323L1907.34 609.968V639.256L1881.96 653.901L1856.58 639.256V609.968L1881.96 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 595.323L1969.17 609.968V639.256L1943.79 653.901L1918.41 639.256V609.968L1943.79 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 595.323L2031 609.968V639.256L2005.62 653.901L1980.24 639.256V609.968L2005.62 595.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 701.536L1412.68 716.18V745.469L1387.3 760.114L1361.92 745.469V716.18L1387.3 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 701.536L1474.51 716.18V745.469L1449.13 760.114L1423.75 745.469V716.18L1449.13 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 701.536L1536.34 716.18V745.469L1510.96 760.114L1485.58 745.469V716.18L1510.96 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 701.536L1598.17 716.18V745.469L1572.79 760.114L1547.41 745.469V716.18L1572.79 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 701.536L1660.01 716.18V745.469L1634.63 760.114L1609.25 745.469V716.18L1634.63 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 701.536L1721.84 716.18V745.469L1696.46 760.114L1671.08 745.469V716.18L1696.46 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 701.536L1783.67 716.18V745.469L1758.29 760.114L1732.91 745.469V716.18L1758.29 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 701.536L1845.5 716.18V745.469L1820.12 760.114L1794.74 745.469V716.18L1820.12 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 701.536L1907.34 716.18V745.469L1881.96 760.114L1856.58 745.469V716.18L1881.96 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 701.536L1969.17 716.18V745.469L1943.79 760.114L1918.41 745.469V716.18L1943.79 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 701.536L2031 716.18V745.469L2005.62 760.114L1980.24 745.469V716.18L2005.62 701.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 807.748L1412.68 822.393V851.682L1387.3 866.326L1361.92 851.682V822.393L1387.3 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 807.748L1474.51 822.393V851.682L1449.13 866.326L1423.75 851.682V822.393L1449.13 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 807.748L1536.34 822.393V851.682L1510.96 866.326L1485.58 851.682V822.393L1510.96 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 807.748L1598.17 822.393V851.682L1572.79 866.326L1547.41 851.682V822.393L1572.79 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 807.748L1660.01 822.393V851.682L1634.63 866.326L1609.25 851.682V822.393L1634.63 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 807.748L1721.84 822.393V851.682L1696.46 866.326L1671.08 851.682V822.393L1696.46 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 807.748L1783.67 822.393V851.682L1758.29 866.326L1732.91 851.682V822.393L1758.29 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 807.748L1845.5 822.393V851.682L1820.12 866.326L1794.74 851.682V822.393L1820.12 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 807.748L1907.34 822.393V851.682L1881.96 866.326L1856.58 851.682V822.393L1881.96 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 807.748L1969.17 822.393V851.682L1943.79 866.326L1918.41 851.682V822.393L1943.79 807.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 807.748L2031 822.393V851.682L2005.62 866.326L1980.24 851.682V822.393L2005.62 807.748Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62022 6.32617L23.7595 20.9706V50.2595L-1.62022 64.904L-27 50.2595V20.9706L-1.62022 6.32617Z",
    stroke: "url(#paint1_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 6.32617L85.5919 20.9706V50.2595L60.2122 64.904L34.8325 50.2595V20.9706L60.2122 6.32617Z",
    stroke: "url(#paint2_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 6.32617L147.424 20.9706V50.2595L122.045 64.904L96.6649 50.2595V20.9706L122.045 6.32617Z",
    stroke: "url(#paint3_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 6.32617L209.257 20.9706V50.2595L183.877 64.904L158.497 50.2595V20.9706L183.877 6.32617Z",
    stroke: "url(#paint4_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 6.32617L271.089 20.9706V50.2595L245.709 64.904L220.33 50.2595V20.9706L245.709 6.32617Z",
    stroke: "url(#paint5_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 6.32617L332.922 20.9706V50.2595L307.542 64.904L282.162 50.2595V20.9706L307.542 6.32617Z",
    stroke: "url(#paint6_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 6.32617L394.754 20.9706V50.2595L369.374 64.904L343.995 50.2595V20.9706L369.374 6.32617Z",
    stroke: "url(#paint7_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 6.32617L456.586 20.9706V50.2595L431.207 64.904L405.827 50.2595V20.9706L431.207 6.32617Z",
    stroke: "url(#paint8_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 6.32617L518.419 20.9706V50.2595L493.039 64.904L467.659 50.2595V20.9706L493.039 6.32617Z",
    stroke: "url(#paint9_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.872 6.32617L580.251 20.9706V50.2595L554.872 64.904L529.492 50.2595V20.9706L554.872 6.32617Z",
    stroke: "url(#paint10_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 6.32617L642.084 20.9706V50.2595L616.704 64.904L591.324 50.2595V20.9706L616.704 6.32617Z",
    stroke: "url(#paint11_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 112.539L23.7595 127.183V156.472L-1.62027 171.117L-27 156.472V127.183L-1.62027 112.539Z",
    stroke: "url(#paint12_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 112.539L85.5919 127.183V156.472L60.2122 171.117L34.8324 156.472V127.183L60.2122 112.539Z",
    stroke: "url(#paint13_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 112.539L147.424 127.183V156.472L122.045 171.117L96.6648 156.472V127.183L122.045 112.539Z",
    stroke: "url(#paint14_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 112.539L209.257 127.183V156.472L183.877 171.117L158.497 156.472V127.183L183.877 112.539Z",
    stroke: "url(#paint15_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 112.539L271.089 127.183V156.472L245.709 171.117L220.33 156.472V127.183L245.709 112.539Z",
    stroke: "url(#paint16_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 112.539L332.922 127.183V156.472L307.542 171.117L282.162 156.472V127.183L307.542 112.539Z",
    stroke: "url(#paint17_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 112.539L394.754 127.183V156.472L369.374 171.117L343.995 156.472V127.183L369.374 112.539Z",
    stroke: "url(#paint18_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 112.539L456.586 127.183V156.472L431.207 171.117L405.827 156.472V127.183L431.207 112.539Z",
    stroke: "url(#paint19_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 112.539L518.419 127.183V156.472L493.039 171.117L467.659 156.472V127.183L493.039 112.539Z",
    stroke: "url(#paint20_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 112.539L580.251 127.183V156.472L554.871 171.117L529.492 156.472V127.183L554.871 112.539Z",
    stroke: "url(#paint21_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 112.539L642.084 127.183V156.472L616.704 171.117L591.324 156.472V127.183L616.704 112.539Z",
    stroke: "url(#paint22_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 218.751L23.7595 233.396V262.685L-1.62027 277.329L-27 262.685V233.396L-1.62027 218.751Z",
    stroke: "url(#paint23_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 218.751L85.5919 233.396V262.685L60.2122 277.329L34.8324 262.685V233.396L60.2122 218.751Z",
    stroke: "url(#paint24_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 218.751L147.424 233.396V262.685L122.045 277.329L96.6648 262.685V233.396L122.045 218.751Z",
    stroke: "url(#paint25_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 218.751L209.257 233.396V262.685L183.877 277.329L158.497 262.685V233.396L183.877 218.751Z",
    stroke: "url(#paint26_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 218.751L271.089 233.396V262.685L245.709 277.329L220.33 262.685V233.396L245.709 218.751Z",
    stroke: "url(#paint27_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 218.751L332.922 233.396V262.685L307.542 277.329L282.162 262.685V233.396L307.542 218.751Z",
    stroke: "url(#paint28_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 218.751L394.754 233.396V262.685L369.374 277.329L343.995 262.685V233.396L369.374 218.751Z",
    stroke: "url(#paint29_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 218.751L456.586 233.396V262.685L431.207 277.329L405.827 262.685V233.396L431.207 218.751Z",
    stroke: "url(#paint30_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 218.751L518.419 233.396V262.685L493.039 277.329L467.659 262.685V233.396L493.039 218.751Z",
    stroke: "url(#paint31_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 218.751L580.251 233.396V262.685L554.871 277.329L529.492 262.685V233.396L554.871 218.751Z",
    stroke: "url(#paint32_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 218.751L642.084 233.396V262.685L616.704 277.329L591.324 262.685V233.396L616.704 218.751Z",
    stroke: "url(#paint33_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 324.964L23.7595 339.608V368.897L-1.62027 383.542L-27 368.897V339.608L-1.62027 324.964Z",
    stroke: "url(#paint34_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 324.964L85.5919 339.608V368.897L60.2122 383.542L34.8324 368.897V339.608L60.2122 324.964Z",
    stroke: "url(#paint35_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 324.964L147.424 339.608V368.897L122.045 383.542L96.6648 368.897V339.608L122.045 324.964Z",
    stroke: "url(#paint36_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 324.964L209.257 339.608V368.897L183.877 383.542L158.497 368.897V339.608L183.877 324.964Z",
    stroke: "url(#paint37_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 324.964L271.089 339.608V368.897L245.709 383.542L220.33 368.897V339.608L245.709 324.964Z",
    stroke: "url(#paint38_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 324.964L332.922 339.608V368.897L307.542 383.542L282.162 368.897V339.608L307.542 324.964Z",
    stroke: "url(#paint39_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 324.964L394.754 339.608V368.897L369.374 383.542L343.995 368.897V339.608L369.374 324.964Z",
    stroke: "url(#paint40_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 324.964L456.586 339.608V368.897L431.207 383.542L405.827 368.897V339.608L431.207 324.964Z",
    stroke: "url(#paint41_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 324.964L518.419 339.608V368.897L493.039 383.542L467.659 368.897V339.608L493.039 324.964Z",
    stroke: "url(#paint42_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 324.964L580.251 339.608V368.897L554.871 383.542L529.492 368.897V339.608L554.871 324.964Z",
    stroke: "url(#paint43_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 324.964L642.084 339.608V368.897L616.704 383.542L591.324 368.897V339.608L616.704 324.964Z",
    stroke: "url(#paint44_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 59.1105L54.6757 73.7549V103.044L29.296 117.688L3.91625 103.044V73.7549L29.296 59.1105Z",
    stroke: "url(#paint45_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 59.1105L116.508 73.7549V103.044L91.1284 117.688L65.7487 103.044V73.7549L91.1284 59.1105Z",
    stroke: "url(#paint46_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 59.1105L178.341 73.7549V103.044L152.961 117.688L127.581 103.044V73.7549L152.961 59.1105Z",
    stroke: "url(#paint47_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 59.1105L240.173 73.7549V103.044L214.793 117.688L189.414 103.044V73.7549L214.793 59.1105Z",
    stroke: "url(#paint48_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 59.1105L302.005 73.7549V103.044L276.626 117.688L251.246 103.044V73.7549L276.626 59.1105Z",
    stroke: "url(#paint49_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 59.1105L363.838 73.7549V103.044L338.458 117.688L313.078 103.044V73.7549L338.458 59.1105Z",
    stroke: "url(#paint50_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 59.1105L425.67 73.7549V103.044L400.291 117.688L374.911 103.044V73.7549L400.291 59.1105Z",
    stroke: "url(#paint51_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 59.1105L487.503 73.7549V103.044L462.123 117.688L436.743 103.044V73.7549L462.123 59.1105Z",
    stroke: "url(#paint52_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 59.1105L549.335 73.7549V103.044L523.955 117.688L498.576 103.044V73.7549L523.955 59.1105Z",
    stroke: "url(#paint53_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 59.1105L611.168 73.7549V103.044L585.788 117.688L560.408 103.044V73.7549L585.788 59.1105Z",
    stroke: "url(#paint54_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 59.1105L673 73.7549V103.044L647.62 117.688L622.241 103.044V73.7549L647.62 59.1105Z",
    stroke: "url(#paint55_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 165.323L54.6757 179.968V209.256L29.296 223.901L3.91625 209.256V179.968L29.296 165.323Z",
    stroke: "url(#paint56_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 165.323L116.508 179.968V209.256L91.1284 223.901L65.7487 209.256V179.968L91.1284 165.323Z",
    stroke: "url(#paint57_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 165.323L178.341 179.968V209.256L152.961 223.901L127.581 209.256V179.968L152.961 165.323Z",
    stroke: "url(#paint58_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 165.323L240.173 179.968V209.256L214.793 223.901L189.414 209.256V179.968L214.793 165.323Z",
    stroke: "url(#paint59_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 165.323L302.005 179.968V209.256L276.626 223.901L251.246 209.256V179.968L276.626 165.323Z",
    stroke: "url(#paint60_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 165.323L363.838 179.968V209.256L338.458 223.901L313.078 209.256V179.968L338.458 165.323Z",
    stroke: "url(#paint61_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 165.323L425.67 179.968V209.256L400.291 223.901L374.911 209.256V179.968L400.291 165.323Z",
    stroke: "url(#paint62_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 165.323L487.503 179.968V209.256L462.123 223.901L436.743 209.256V179.968L462.123 165.323Z",
    stroke: "url(#paint63_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 165.323L549.335 179.968V209.256L523.955 223.901L498.576 209.256V179.968L523.955 165.323Z",
    stroke: "url(#paint64_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 165.323L611.168 179.968V209.256L585.788 223.901L560.408 209.256V179.968L585.788 165.323Z",
    stroke: "url(#paint65_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 165.323L673 179.968V209.256L647.62 223.901L622.241 209.256V179.968L647.62 165.323Z",
    stroke: "url(#paint66_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 271.536L54.6757 286.18V315.469L29.296 330.113L3.91625 315.469V286.18L29.296 271.536Z",
    stroke: "url(#paint67_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 271.536L116.508 286.18V315.469L91.1284 330.113L65.7487 315.469V286.18L91.1284 271.536Z",
    stroke: "url(#paint68_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 271.536L178.341 286.18V315.469L152.961 330.113L127.581 315.469V286.18L152.961 271.536Z",
    stroke: "url(#paint69_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 271.536L240.173 286.18V315.469L214.793 330.113L189.414 315.469V286.18L214.793 271.536Z",
    stroke: "url(#paint70_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 271.536L302.005 286.18V315.469L276.626 330.113L251.246 315.469V286.18L276.626 271.536Z",
    stroke: "url(#paint71_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 271.536L363.838 286.18V315.469L338.458 330.113L313.078 315.469V286.18L338.458 271.536Z",
    stroke: "url(#paint72_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 271.536L425.67 286.18V315.469L400.291 330.113L374.911 315.469V286.18L400.291 271.536Z",
    stroke: "url(#paint73_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 271.536L487.503 286.18V315.469L462.123 330.113L436.743 315.469V286.18L462.123 271.536Z",
    stroke: "url(#paint74_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 271.536L549.335 286.18V315.469L523.955 330.113L498.576 315.469V286.18L523.955 271.536Z",
    stroke: "url(#paint75_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 271.536L611.168 286.18V315.469L585.788 330.113L560.408 315.469V286.18L585.788 271.536Z",
    stroke: "url(#paint76_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 271.536L673 286.18V315.469L647.62 330.113L622.241 315.469V286.18L647.62 271.536Z",
    stroke: "url(#paint77_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 377.748L54.6757 392.393V421.682L29.296 436.326L3.91625 421.682V392.393L29.296 377.748Z",
    stroke: "url(#paint78_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 377.748L116.508 392.393V421.682L91.1284 436.326L65.7487 421.682V392.393L91.1284 377.748Z",
    stroke: "url(#paint79_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 377.748L178.341 392.393V421.682L152.961 436.326L127.581 421.682V392.393L152.961 377.748Z",
    stroke: "url(#paint80_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 377.748L240.173 392.393V421.682L214.793 436.326L189.414 421.682V392.393L214.793 377.748Z",
    stroke: "url(#paint81_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 377.748L302.005 392.393V421.682L276.626 436.326L251.246 421.682V392.393L276.626 377.748Z",
    stroke: "url(#paint82_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 377.748L363.838 392.393V421.682L338.458 436.326L313.078 421.682V392.393L338.458 377.748Z",
    stroke: "url(#paint83_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 377.748L425.67 392.393V421.682L400.291 436.326L374.911 421.682V392.393L400.291 377.748Z",
    stroke: "url(#paint84_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 377.748L487.503 392.393V421.682L462.123 436.326L436.743 421.682V392.393L462.123 377.748Z",
    stroke: "url(#paint85_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 377.748L549.335 392.393V421.682L523.955 436.326L498.576 421.682V392.393L523.955 377.748Z",
    stroke: "url(#paint86_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 377.748L611.168 392.393V421.682L585.788 436.326L560.408 421.682V392.393L585.788 377.748Z",
    stroke: "url(#paint87_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 377.748L673 392.393V421.682L647.62 436.326L622.241 421.682V392.393L647.62 377.748Z",
    stroke: "url(#paint88_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62022 436.326L23.7595 450.971V480.26L-1.62022 494.904L-27 480.26V450.971L-1.62022 436.326Z",
    stroke: "url(#paint89_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 436.326L85.5919 450.971V480.26L60.2122 494.904L34.8325 480.26V450.971L60.2122 436.326Z",
    stroke: "url(#paint90_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 436.326L147.424 450.971V480.26L122.045 494.904L96.6649 480.26V450.971L122.045 436.326Z",
    stroke: "url(#paint91_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 436.326L209.257 450.971V480.26L183.877 494.904L158.497 480.26V450.971L183.877 436.326Z",
    stroke: "url(#paint92_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 436.326L271.089 450.971V480.26L245.709 494.904L220.33 480.26V450.971L245.709 436.326Z",
    stroke: "url(#paint93_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 436.326L332.922 450.971V480.26L307.542 494.904L282.162 480.26V450.971L307.542 436.326Z",
    stroke: "url(#paint94_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 436.326L394.754 450.971V480.26L369.374 494.904L343.995 480.26V450.971L369.374 436.326Z",
    stroke: "url(#paint95_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 436.326L456.586 450.971V480.26L431.207 494.904L405.827 480.26V450.971L431.207 436.326Z",
    stroke: "url(#paint96_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 436.326L518.419 450.971V480.26L493.039 494.904L467.659 480.26V450.971L493.039 436.326Z",
    stroke: "url(#paint97_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.872 436.326L580.251 450.971V480.26L554.872 494.904L529.492 480.26V450.971L554.872 436.326Z",
    stroke: "url(#paint98_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 436.326L642.084 450.971V480.26L616.704 494.904L591.324 480.26V450.971L616.704 436.326Z",
    stroke: "url(#paint99_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 542.539L23.7595 557.183V586.472L-1.62027 601.117L-27 586.472V557.183L-1.62027 542.539Z",
    stroke: "url(#paint100_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 542.539L85.5919 557.183V586.472L60.2122 601.117L34.8324 586.472V557.183L60.2122 542.539Z",
    stroke: "url(#paint101_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 542.539L147.424 557.183V586.472L122.045 601.117L96.6648 586.472V557.183L122.045 542.539Z",
    stroke: "url(#paint102_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 542.539L209.257 557.183V586.472L183.877 601.117L158.497 586.472V557.183L183.877 542.539Z",
    stroke: "url(#paint103_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 542.539L271.089 557.183V586.472L245.709 601.117L220.33 586.472V557.183L245.709 542.539Z",
    stroke: "url(#paint104_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 542.539L332.922 557.183V586.472L307.542 601.117L282.162 586.472V557.183L307.542 542.539Z",
    stroke: "url(#paint105_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 542.539L394.754 557.183V586.472L369.374 601.117L343.995 586.472V557.183L369.374 542.539Z",
    stroke: "url(#paint106_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 542.539L456.586 557.183V586.472L431.207 601.117L405.827 586.472V557.183L431.207 542.539Z",
    stroke: "url(#paint107_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 542.539L518.419 557.183V586.472L493.039 601.117L467.659 586.472V557.183L493.039 542.539Z",
    stroke: "url(#paint108_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 542.539L580.251 557.183V586.472L554.871 601.117L529.492 586.472V557.183L554.871 542.539Z",
    stroke: "url(#paint109_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 542.539L642.084 557.183V586.472L616.704 601.117L591.324 586.472V557.183L616.704 542.539Z",
    stroke: "url(#paint110_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 648.751L23.7595 663.396V692.685L-1.62027 707.329L-27 692.685V663.396L-1.62027 648.751Z",
    stroke: "url(#paint111_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 648.751L85.5919 663.396V692.685L60.2122 707.329L34.8324 692.685V663.396L60.2122 648.751Z",
    stroke: "url(#paint112_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 648.751L147.424 663.396V692.685L122.045 707.329L96.6648 692.685V663.396L122.045 648.751Z",
    stroke: "url(#paint113_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 648.751L209.257 663.396V692.685L183.877 707.329L158.497 692.685V663.396L183.877 648.751Z",
    stroke: "url(#paint114_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 648.751L271.089 663.396V692.685L245.709 707.329L220.33 692.685V663.396L245.709 648.751Z",
    stroke: "url(#paint115_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 648.751L332.922 663.396V692.685L307.542 707.329L282.162 692.685V663.396L307.542 648.751Z",
    stroke: "url(#paint116_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 648.751L394.754 663.396V692.685L369.374 707.329L343.995 692.685V663.396L369.374 648.751Z",
    stroke: "url(#paint117_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 648.751L456.586 663.396V692.685L431.207 707.329L405.827 692.685V663.396L431.207 648.751Z",
    stroke: "url(#paint118_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 648.751L518.419 663.396V692.685L493.039 707.329L467.659 692.685V663.396L493.039 648.751Z",
    stroke: "url(#paint119_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 648.751L580.251 663.396V692.685L554.871 707.329L529.492 692.685V663.396L554.871 648.751Z",
    stroke: "url(#paint120_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 648.751L642.084 663.396V692.685L616.704 707.329L591.324 692.685V663.396L616.704 648.751Z",
    stroke: "url(#paint121_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62027 754.964L23.7595 769.608V798.897L-1.62027 813.542L-27 798.897V769.608L-1.62027 754.964Z",
    stroke: "url(#paint122_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2122 754.964L85.5919 769.608V798.897L60.2122 813.542L34.8324 798.897V769.608L60.2122 754.964Z",
    stroke: "url(#paint123_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.045 754.964L147.424 769.608V798.897L122.045 813.542L96.6648 798.897V769.608L122.045 754.964Z",
    stroke: "url(#paint124_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 754.964L209.257 769.608V798.897L183.877 813.542L158.497 798.897V769.608L183.877 754.964Z",
    stroke: "url(#paint125_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.709 754.964L271.089 769.608V798.897L245.709 813.542L220.33 798.897V769.608L245.709 754.964Z",
    stroke: "url(#paint126_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.542 754.964L332.922 769.608V798.897L307.542 813.542L282.162 798.897V769.608L307.542 754.964Z",
    stroke: "url(#paint127_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 754.964L394.754 769.608V798.897L369.374 813.542L343.995 798.897V769.608L369.374 754.964Z",
    stroke: "url(#paint128_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.207 754.964L456.586 769.608V798.897L431.207 813.542L405.827 798.897V769.608L431.207 754.964Z",
    stroke: "url(#paint129_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.039 754.964L518.419 769.608V798.897L493.039 813.542L467.659 798.897V769.608L493.039 754.964Z",
    stroke: "url(#paint130_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.871 754.964L580.251 769.608V798.897L554.871 813.542L529.492 798.897V769.608L554.871 754.964Z",
    stroke: "url(#paint131_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.704 754.964L642.084 769.608V798.897L616.704 813.542L591.324 798.897V769.608L616.704 754.964Z",
    stroke: "url(#paint132_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 489.11L54.6757 503.755V533.044L29.296 547.688L3.91625 533.044V503.755L29.296 489.11Z",
    stroke: "url(#paint133_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 489.11L116.508 503.755V533.044L91.1284 547.688L65.7487 533.044V503.755L91.1284 489.11Z",
    stroke: "url(#paint134_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 489.11L178.341 503.755V533.044L152.961 547.688L127.581 533.044V503.755L152.961 489.11Z",
    stroke: "url(#paint135_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 489.11L240.173 503.755V533.044L214.793 547.688L189.414 533.044V503.755L214.793 489.11Z",
    stroke: "url(#paint136_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 489.11L302.005 503.755V533.044L276.626 547.688L251.246 533.044V503.755L276.626 489.11Z",
    stroke: "url(#paint137_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 489.11L363.838 503.755V533.044L338.458 547.688L313.078 533.044V503.755L338.458 489.11Z",
    stroke: "url(#paint138_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 489.11L425.67 503.755V533.044L400.291 547.688L374.911 533.044V503.755L400.291 489.11Z",
    stroke: "url(#paint139_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 489.11L487.503 503.755V533.044L462.123 547.688L436.743 533.044V503.755L462.123 489.11Z",
    stroke: "url(#paint140_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 489.11L549.335 503.755V533.044L523.955 547.688L498.576 533.044V503.755L523.955 489.11Z",
    stroke: "url(#paint141_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 489.11L611.168 503.755V533.044L585.788 547.688L560.408 533.044V503.755L585.788 489.11Z",
    stroke: "url(#paint142_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 489.11L673 503.755V533.044L647.62 547.688L622.241 533.044V503.755L647.62 489.11Z",
    stroke: "url(#paint143_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 595.323L54.6757 609.968V639.256L29.296 653.901L3.91625 639.256V609.968L29.296 595.323Z",
    stroke: "url(#paint144_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 595.323L116.508 609.968V639.256L91.1284 653.901L65.7487 639.256V609.968L91.1284 595.323Z",
    stroke: "url(#paint145_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 595.323L178.341 609.968V639.256L152.961 653.901L127.581 639.256V609.968L152.961 595.323Z",
    stroke: "url(#paint146_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 595.323L240.173 609.968V639.256L214.793 653.901L189.414 639.256V609.968L214.793 595.323Z",
    stroke: "url(#paint147_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 595.323L302.005 609.968V639.256L276.626 653.901L251.246 639.256V609.968L276.626 595.323Z",
    stroke: "url(#paint148_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 595.323L363.838 609.968V639.256L338.458 653.901L313.078 639.256V609.968L338.458 595.323Z",
    stroke: "url(#paint149_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 595.323L425.67 609.968V639.256L400.291 653.901L374.911 639.256V609.968L400.291 595.323Z",
    stroke: "url(#paint150_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 595.323L487.503 609.968V639.256L462.123 653.901L436.743 639.256V609.968L462.123 595.323Z",
    stroke: "url(#paint151_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 595.323L549.335 609.968V639.256L523.955 653.901L498.576 639.256V609.968L523.955 595.323Z",
    stroke: "url(#paint152_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 595.323L611.168 609.968V639.256L585.788 653.901L560.408 639.256V609.968L585.788 595.323Z",
    stroke: "url(#paint153_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 595.323L673 609.968V639.256L647.62 653.901L622.241 639.256V609.968L647.62 595.323Z",
    stroke: "url(#paint154_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 701.536L54.6757 716.18V745.469L29.296 760.114L3.91625 745.469V716.18L29.296 701.536Z",
    stroke: "url(#paint155_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 701.536L116.508 716.18V745.469L91.1284 760.114L65.7487 745.469V716.18L91.1284 701.536Z",
    stroke: "url(#paint156_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 701.536L178.341 716.18V745.469L152.961 760.114L127.581 745.469V716.18L152.961 701.536Z",
    stroke: "url(#paint157_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 701.536L240.173 716.18V745.469L214.793 760.114L189.414 745.469V716.18L214.793 701.536Z",
    stroke: "url(#paint158_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 701.536L302.005 716.18V745.469L276.626 760.114L251.246 745.469V716.18L276.626 701.536Z",
    stroke: "url(#paint159_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 701.536L363.838 716.18V745.469L338.458 760.114L313.078 745.469V716.18L338.458 701.536Z",
    stroke: "url(#paint160_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 701.536L425.67 716.18V745.469L400.291 760.114L374.911 745.469V716.18L400.291 701.536Z",
    stroke: "url(#paint161_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 701.536L487.503 716.18V745.469L462.123 760.114L436.743 745.469V716.18L462.123 701.536Z",
    stroke: "url(#paint162_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 701.536L549.335 716.18V745.469L523.955 760.114L498.576 745.469V716.18L523.955 701.536Z",
    stroke: "url(#paint163_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 701.536L611.168 716.18V745.469L585.788 760.114L560.408 745.469V716.18L585.788 701.536Z",
    stroke: "url(#paint164_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 701.536L673 716.18V745.469L647.62 760.114L622.241 745.469V716.18L647.62 701.536Z",
    stroke: "url(#paint165_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.296 807.748L54.6757 822.393V851.682L29.296 866.326L3.91625 851.682V822.393L29.296 807.748Z",
    stroke: "url(#paint166_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1284 807.748L116.508 822.393V851.682L91.1284 866.326L65.7487 851.682V822.393L91.1284 807.748Z",
    stroke: "url(#paint167_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 807.748L178.341 822.393V851.682L152.961 866.326L127.581 851.682V822.393L152.961 807.748Z",
    stroke: "url(#paint168_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 807.748L240.173 822.393V851.682L214.793 866.326L189.414 851.682V822.393L214.793 807.748Z",
    stroke: "url(#paint169_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.626 807.748L302.005 822.393V851.682L276.626 866.326L251.246 851.682V822.393L276.626 807.748Z",
    stroke: "url(#paint170_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.458 807.748L363.838 822.393V851.682L338.458 866.326L313.078 851.682V822.393L338.458 807.748Z",
    stroke: "url(#paint171_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.291 807.748L425.67 822.393V851.682L400.291 866.326L374.911 851.682V822.393L400.291 807.748Z",
    stroke: "url(#paint172_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 807.748L487.503 822.393V851.682L462.123 866.326L436.743 851.682V822.393L462.123 807.748Z",
    stroke: "url(#paint173_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.955 807.748L549.335 822.393V851.682L523.955 866.326L498.576 851.682V822.393L523.955 807.748Z",
    stroke: "url(#paint174_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.788 807.748L611.168 822.393V851.682L585.788 866.326L560.408 851.682V822.393L585.788 807.748Z",
    stroke: "url(#paint175_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.62 807.748L673 822.393V851.682L647.62 866.326L622.241 851.682V822.393L647.62 807.748Z",
    stroke: "url(#paint176_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 6.32617L702.76 20.9706V50.2595L677.38 64.904L652 50.2595V20.9706L677.38 6.32617Z",
    stroke: "url(#paint177_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 6.32617L764.592 20.9706V50.2595L739.212 64.904L713.832 50.2595V20.9706L739.212 6.32617Z",
    stroke: "url(#paint178_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 6.32617L826.424 20.9706V50.2595L801.045 64.904L775.665 50.2595V20.9706L801.045 6.32617Z",
    stroke: "url(#paint179_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 6.32617L888.257 20.9706V50.2595L862.877 64.904L837.497 50.2595V20.9706L862.877 6.32617Z",
    stroke: "url(#paint180_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 6.32617L950.089 20.9706V50.2595L924.709 64.904L899.33 50.2595V20.9706L924.709 6.32617Z",
    stroke: "url(#paint181_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 6.32617L1011.92 20.9706V50.2595L986.542 64.904L961.162 50.2595V20.9706L986.542 6.32617Z",
    stroke: "url(#paint182_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 6.32617L1073.75 20.9706V50.2595L1048.37 64.904L1022.99 50.2595V20.9706L1048.37 6.32617Z",
    stroke: "url(#paint183_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 6.32617L1135.59 20.9706V50.2595L1110.21 64.904L1084.83 50.2595V20.9706L1110.21 6.32617Z",
    stroke: "url(#paint184_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 6.32617L1197.42 20.9706V50.2595L1172.04 64.904L1146.66 50.2595V20.9706L1172.04 6.32617Z",
    stroke: "url(#paint185_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 6.32617L1259.25 20.9706V50.2595L1233.87 64.904L1208.49 50.2595V20.9706L1233.87 6.32617Z",
    stroke: "url(#paint186_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 6.32617L1321.08 20.9706V50.2595L1295.7 64.904L1270.32 50.2595V20.9706L1295.7 6.32617Z",
    stroke: "url(#paint187_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 112.539L702.759 127.183V156.472L677.38 171.117L652 156.472V127.183L677.38 112.539Z",
    stroke: "url(#paint188_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 112.539L764.592 127.183V156.472L739.212 171.117L713.832 156.472V127.183L739.212 112.539Z",
    stroke: "url(#paint189_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 112.539L826.424 127.183V156.472L801.045 171.117L775.665 156.472V127.183L801.045 112.539Z",
    stroke: "url(#paint190_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 112.539L888.257 127.183V156.472L862.877 171.117L837.497 156.472V127.183L862.877 112.539Z",
    stroke: "url(#paint191_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 112.539L950.089 127.183V156.472L924.709 171.117L899.33 156.472V127.183L924.709 112.539Z",
    stroke: "url(#paint192_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 112.539L1011.92 127.183V156.472L986.542 171.117L961.162 156.472V127.183L986.542 112.539Z",
    stroke: "url(#paint193_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 112.539L1073.75 127.183V156.472L1048.37 171.117L1022.99 156.472V127.183L1048.37 112.539Z",
    stroke: "url(#paint194_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 112.539L1135.59 127.183V156.472L1110.21 171.117L1084.83 156.472V127.183L1110.21 112.539Z",
    stroke: "url(#paint195_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 112.539L1197.42 127.183V156.472L1172.04 171.117L1146.66 156.472V127.183L1172.04 112.539Z",
    stroke: "url(#paint196_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 112.539L1259.25 127.183V156.472L1233.87 171.117L1208.49 156.472V127.183L1233.87 112.539Z",
    stroke: "url(#paint197_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 112.539L1321.08 127.183V156.472L1295.7 171.117L1270.32 156.472V127.183L1295.7 112.539Z",
    stroke: "url(#paint198_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 218.751L702.759 233.396V262.685L677.38 277.329L652 262.685V233.396L677.38 218.751Z",
    stroke: "url(#paint199_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 218.751L764.592 233.396V262.685L739.212 277.329L713.832 262.685V233.396L739.212 218.751Z",
    stroke: "url(#paint200_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 218.751L826.424 233.396V262.685L801.045 277.329L775.665 262.685V233.396L801.045 218.751Z",
    stroke: "url(#paint201_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 218.751L888.257 233.396V262.685L862.877 277.329L837.497 262.685V233.396L862.877 218.751Z",
    stroke: "url(#paint202_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 218.751L950.089 233.396V262.685L924.709 277.329L899.33 262.685V233.396L924.709 218.751Z",
    stroke: "url(#paint203_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 218.751L1011.92 233.396V262.685L986.542 277.329L961.162 262.685V233.396L986.542 218.751Z",
    stroke: "url(#paint204_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 218.751L1073.75 233.396V262.685L1048.37 277.329L1022.99 262.685V233.396L1048.37 218.751Z",
    stroke: "url(#paint205_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 218.751L1135.59 233.396V262.685L1110.21 277.329L1084.83 262.685V233.396L1110.21 218.751Z",
    stroke: "url(#paint206_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 218.751L1197.42 233.396V262.685L1172.04 277.329L1146.66 262.685V233.396L1172.04 218.751Z",
    stroke: "url(#paint207_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 218.751L1259.25 233.396V262.685L1233.87 277.329L1208.49 262.685V233.396L1233.87 218.751Z",
    stroke: "url(#paint208_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 218.751L1321.08 233.396V262.685L1295.7 277.329L1270.32 262.685V233.396L1295.7 218.751Z",
    stroke: "url(#paint209_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 324.964L702.759 339.608V368.897L677.38 383.542L652 368.897V339.608L677.38 324.964Z",
    stroke: "url(#paint210_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 324.964L764.592 339.608V368.897L739.212 383.542L713.832 368.897V339.608L739.212 324.964Z",
    stroke: "url(#paint211_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 324.964L826.424 339.608V368.897L801.045 383.542L775.665 368.897V339.608L801.045 324.964Z",
    stroke: "url(#paint212_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 324.964L888.257 339.608V368.897L862.877 383.542L837.497 368.897V339.608L862.877 324.964Z",
    stroke: "url(#paint213_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 324.964L950.089 339.608V368.897L924.709 383.542L899.33 368.897V339.608L924.709 324.964Z",
    stroke: "url(#paint214_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 324.964L1011.92 339.608V368.897L986.542 383.542L961.162 368.897V339.608L986.542 324.964Z",
    stroke: "url(#paint215_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 324.964L1073.75 339.608V368.897L1048.37 383.542L1022.99 368.897V339.608L1048.37 324.964Z",
    stroke: "url(#paint216_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 324.964L1135.59 339.608V368.897L1110.21 383.542L1084.83 368.897V339.608L1110.21 324.964Z",
    stroke: "url(#paint217_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 324.964L1197.42 339.608V368.897L1172.04 383.542L1146.66 368.897V339.608L1172.04 324.964Z",
    stroke: "url(#paint218_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 324.964L1259.25 339.608V368.897L1233.87 383.542L1208.49 368.897V339.608L1233.87 324.964Z",
    stroke: "url(#paint219_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 324.964L1321.08 339.608V368.897L1295.7 383.542L1270.32 368.897V339.608L1295.7 324.964Z",
    stroke: "url(#paint220_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 59.1105L733.676 73.7549V103.044L708.296 117.688L682.916 103.044V73.7549L708.296 59.1105Z",
    stroke: "url(#paint221_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 59.1105L795.508 73.7549V103.044L770.128 117.688L744.749 103.044V73.7549L770.128 59.1105Z",
    stroke: "url(#paint222_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 59.1105L857.341 73.7549V103.044L831.961 117.688L806.581 103.044V73.7549L831.961 59.1105Z",
    stroke: "url(#paint223_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 59.1105L919.173 73.7549V103.044L893.793 117.688L868.414 103.044V73.7549L893.793 59.1105Z",
    stroke: "url(#paint224_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 59.1105L981.005 73.7549V103.044L955.626 117.688L930.246 103.044V73.7549L955.626 59.1105Z",
    stroke: "url(#paint225_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 59.1105L1042.84 73.7549V103.044L1017.46 117.688L992.078 103.044V73.7549L1017.46 59.1105Z",
    stroke: "url(#paint226_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 59.1105L1104.67 73.7549V103.044L1079.29 117.688L1053.91 103.044V73.7549L1079.29 59.1105Z",
    stroke: "url(#paint227_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 59.1105L1166.5 73.7549V103.044L1141.12 117.688L1115.74 103.044V73.7549L1141.12 59.1105Z",
    stroke: "url(#paint228_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 59.1105L1228.34 73.7549V103.044L1202.96 117.688L1177.58 103.044V73.7549L1202.96 59.1105Z",
    stroke: "url(#paint229_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 59.1105L1290.17 73.7549V103.044L1264.79 117.688L1239.41 103.044V73.7549L1264.79 59.1105Z",
    stroke: "url(#paint230_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 59.1105L1352 73.7549V103.044L1326.62 117.688L1301.24 103.044V73.7549L1326.62 59.1105Z",
    stroke: "url(#paint231_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 165.323L733.676 179.968V209.256L708.296 223.901L682.916 209.256V179.968L708.296 165.323Z",
    stroke: "url(#paint232_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 165.323L795.508 179.968V209.256L770.128 223.901L744.749 209.256V179.968L770.128 165.323Z",
    stroke: "url(#paint233_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 165.323L857.341 179.968V209.256L831.961 223.901L806.581 209.256V179.968L831.961 165.323Z",
    stroke: "url(#paint234_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 165.323L919.173 179.968V209.256L893.793 223.901L868.414 209.256V179.968L893.793 165.323Z",
    stroke: "url(#paint235_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 165.323L981.005 179.968V209.256L955.626 223.901L930.246 209.256V179.968L955.626 165.323Z",
    stroke: "url(#paint236_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 165.323L1042.84 179.968V209.256L1017.46 223.901L992.078 209.256V179.968L1017.46 165.323Z",
    stroke: "url(#paint237_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 165.323L1104.67 179.968V209.256L1079.29 223.901L1053.91 209.256V179.968L1079.29 165.323Z",
    stroke: "url(#paint238_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 165.323L1166.5 179.968V209.256L1141.12 223.901L1115.74 209.256V179.968L1141.12 165.323Z",
    stroke: "url(#paint239_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 165.323L1228.34 179.968V209.256L1202.96 223.901L1177.58 209.256V179.968L1202.96 165.323Z",
    stroke: "url(#paint240_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 165.323L1290.17 179.968V209.256L1264.79 223.901L1239.41 209.256V179.968L1264.79 165.323Z",
    stroke: "url(#paint241_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 165.323L1352 179.968V209.256L1326.62 223.901L1301.24 209.256V179.968L1326.62 165.323Z",
    stroke: "url(#paint242_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 271.536L733.676 286.18V315.469L708.296 330.113L682.916 315.469V286.18L708.296 271.536Z",
    stroke: "url(#paint243_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 271.536L795.508 286.18V315.469L770.128 330.113L744.749 315.469V286.18L770.128 271.536Z",
    stroke: "url(#paint244_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 271.536L857.341 286.18V315.469L831.961 330.113L806.581 315.469V286.18L831.961 271.536Z",
    stroke: "url(#paint245_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 271.536L919.173 286.18V315.469L893.793 330.113L868.414 315.469V286.18L893.793 271.536Z",
    stroke: "url(#paint246_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 271.536L981.005 286.18V315.469L955.626 330.113L930.246 315.469V286.18L955.626 271.536Z",
    stroke: "url(#paint247_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 271.536L1042.84 286.18V315.469L1017.46 330.113L992.078 315.469V286.18L1017.46 271.536Z",
    stroke: "url(#paint248_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 271.536L1104.67 286.18V315.469L1079.29 330.113L1053.91 315.469V286.18L1079.29 271.536Z",
    stroke: "url(#paint249_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 271.536L1166.5 286.18V315.469L1141.12 330.113L1115.74 315.469V286.18L1141.12 271.536Z",
    stroke: "url(#paint250_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 271.536L1228.34 286.18V315.469L1202.96 330.113L1177.58 315.469V286.18L1202.96 271.536Z",
    stroke: "url(#paint251_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 271.536L1290.17 286.18V315.469L1264.79 330.113L1239.41 315.469V286.18L1264.79 271.536Z",
    stroke: "url(#paint252_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 271.536L1352 286.18V315.469L1326.62 330.113L1301.24 315.469V286.18L1326.62 271.536Z",
    stroke: "url(#paint253_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 377.748L733.676 392.393V421.682L708.296 436.326L682.916 421.682V392.393L708.296 377.748Z",
    stroke: "url(#paint254_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 377.748L795.508 392.393V421.682L770.128 436.326L744.749 421.682V392.393L770.128 377.748Z",
    stroke: "url(#paint255_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 377.748L857.341 392.393V421.682L831.961 436.326L806.581 421.682V392.393L831.961 377.748Z",
    stroke: "url(#paint256_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 377.748L919.173 392.393V421.682L893.793 436.326L868.414 421.682V392.393L893.793 377.748Z",
    stroke: "url(#paint257_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 377.748L981.005 392.393V421.682L955.626 436.326L930.246 421.682V392.393L955.626 377.748Z",
    stroke: "url(#paint258_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 377.748L1042.84 392.393V421.682L1017.46 436.326L992.078 421.682V392.393L1017.46 377.748Z",
    stroke: "url(#paint259_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 377.748L1104.67 392.393V421.682L1079.29 436.326L1053.91 421.682V392.393L1079.29 377.748Z",
    stroke: "url(#paint260_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 377.748L1166.5 392.393V421.682L1141.12 436.326L1115.74 421.682V392.393L1141.12 377.748Z",
    stroke: "url(#paint261_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 377.748L1228.34 392.393V421.682L1202.96 436.326L1177.58 421.682V392.393L1202.96 377.748Z",
    stroke: "url(#paint262_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 377.748L1290.17 392.393V421.682L1264.79 436.326L1239.41 421.682V392.393L1264.79 377.748Z",
    stroke: "url(#paint263_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 377.748L1352 392.393V421.682L1326.62 436.326L1301.24 421.682V392.393L1326.62 377.748Z",
    stroke: "url(#paint264_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 436.326L702.76 450.971V480.26L677.38 494.904L652 480.26V450.971L677.38 436.326Z",
    stroke: "url(#paint265_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 436.326L764.592 450.971V480.26L739.212 494.904L713.832 480.26V450.971L739.212 436.326Z",
    stroke: "url(#paint266_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 436.326L826.424 450.971V480.26L801.045 494.904L775.665 480.26V450.971L801.045 436.326Z",
    stroke: "url(#paint267_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 436.326L888.257 450.971V480.26L862.877 494.904L837.497 480.26V450.971L862.877 436.326Z",
    stroke: "url(#paint268_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 436.326L950.089 450.971V480.26L924.709 494.904L899.33 480.26V450.971L924.709 436.326Z",
    stroke: "url(#paint269_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 436.326L1011.92 450.971V480.26L986.542 494.904L961.162 480.26V450.971L986.542 436.326Z",
    stroke: "url(#paint270_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 436.326L1073.75 450.971V480.26L1048.37 494.904L1022.99 480.26V450.971L1048.37 436.326Z",
    stroke: "url(#paint271_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 436.326L1135.59 450.971V480.26L1110.21 494.904L1084.83 480.26V450.971L1110.21 436.326Z",
    stroke: "url(#paint272_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 436.326L1197.42 450.971V480.26L1172.04 494.904L1146.66 480.26V450.971L1172.04 436.326Z",
    stroke: "url(#paint273_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 436.326L1259.25 450.971V480.26L1233.87 494.904L1208.49 480.26V450.971L1233.87 436.326Z",
    stroke: "url(#paint274_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 436.326L1321.08 450.971V480.26L1295.7 494.904L1270.32 480.26V450.971L1295.7 436.326Z",
    stroke: "url(#paint275_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 542.539L702.759 557.183V586.472L677.38 601.117L652 586.472V557.183L677.38 542.539Z",
    stroke: "url(#paint276_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 542.539L764.592 557.183V586.472L739.212 601.117L713.832 586.472V557.183L739.212 542.539Z",
    stroke: "url(#paint277_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 542.539L826.424 557.183V586.472L801.045 601.117L775.665 586.472V557.183L801.045 542.539Z",
    stroke: "url(#paint278_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 542.539L888.257 557.183V586.472L862.877 601.117L837.497 586.472V557.183L862.877 542.539Z",
    stroke: "url(#paint279_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 542.539L950.089 557.183V586.472L924.709 601.117L899.33 586.472V557.183L924.709 542.539Z",
    stroke: "url(#paint280_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 542.539L1011.92 557.183V586.472L986.542 601.117L961.162 586.472V557.183L986.542 542.539Z",
    stroke: "url(#paint281_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 542.539L1073.75 557.183V586.472L1048.37 601.117L1022.99 586.472V557.183L1048.37 542.539Z",
    stroke: "url(#paint282_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 542.539L1135.59 557.183V586.472L1110.21 601.117L1084.83 586.472V557.183L1110.21 542.539Z",
    stroke: "url(#paint283_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 542.539L1197.42 557.183V586.472L1172.04 601.117L1146.66 586.472V557.183L1172.04 542.539Z",
    stroke: "url(#paint284_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 542.539L1259.25 557.183V586.472L1233.87 601.117L1208.49 586.472V557.183L1233.87 542.539Z",
    stroke: "url(#paint285_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 542.539L1321.08 557.183V586.472L1295.7 601.117L1270.32 586.472V557.183L1295.7 542.539Z",
    stroke: "url(#paint286_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 648.751L702.759 663.396V692.685L677.38 707.329L652 692.685V663.396L677.38 648.751Z",
    stroke: "url(#paint287_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 648.751L764.592 663.396V692.685L739.212 707.329L713.832 692.685V663.396L739.212 648.751Z",
    stroke: "url(#paint288_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 648.751L826.424 663.396V692.685L801.045 707.329L775.665 692.685V663.396L801.045 648.751Z",
    stroke: "url(#paint289_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 648.751L888.257 663.396V692.685L862.877 707.329L837.497 692.685V663.396L862.877 648.751Z",
    stroke: "url(#paint290_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 648.751L950.089 663.396V692.685L924.709 707.329L899.33 692.685V663.396L924.709 648.751Z",
    stroke: "url(#paint291_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 648.751L1011.92 663.396V692.685L986.542 707.329L961.162 692.685V663.396L986.542 648.751Z",
    stroke: "url(#paint292_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 648.751L1073.75 663.396V692.685L1048.37 707.329L1022.99 692.685V663.396L1048.37 648.751Z",
    stroke: "url(#paint293_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 648.751L1135.59 663.396V692.685L1110.21 707.329L1084.83 692.685V663.396L1110.21 648.751Z",
    stroke: "url(#paint294_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 648.751L1197.42 663.396V692.685L1172.04 707.329L1146.66 692.685V663.396L1172.04 648.751Z",
    stroke: "url(#paint295_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 648.751L1259.25 663.396V692.685L1233.87 707.329L1208.49 692.685V663.396L1233.87 648.751Z",
    stroke: "url(#paint296_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 648.751L1321.08 663.396V692.685L1295.7 707.329L1270.32 692.685V663.396L1295.7 648.751Z",
    stroke: "url(#paint297_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.38 754.964L702.759 769.608V798.897L677.38 813.542L652 798.897V769.608L677.38 754.964Z",
    stroke: "url(#paint298_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.212 754.964L764.592 769.608V798.897L739.212 813.542L713.832 798.897V769.608L739.212 754.964Z",
    stroke: "url(#paint299_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.045 754.964L826.424 769.608V798.897L801.045 813.542L775.665 798.897V769.608L801.045 754.964Z",
    stroke: "url(#paint300_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.877 754.964L888.257 769.608V798.897L862.877 813.542L837.497 798.897V769.608L862.877 754.964Z",
    stroke: "url(#paint301_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.709 754.964L950.089 769.608V798.897L924.709 813.542L899.33 798.897V769.608L924.709 754.964Z",
    stroke: "url(#paint302_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.542 754.964L1011.92 769.608V798.897L986.542 813.542L961.162 798.897V769.608L986.542 754.964Z",
    stroke: "url(#paint303_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.37 754.964L1073.75 769.608V798.897L1048.37 813.542L1022.99 798.897V769.608L1048.37 754.964Z",
    stroke: "url(#paint304_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.21 754.964L1135.59 769.608V798.897L1110.21 813.542L1084.83 798.897V769.608L1110.21 754.964Z",
    stroke: "url(#paint305_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.04 754.964L1197.42 769.608V798.897L1172.04 813.542L1146.66 798.897V769.608L1172.04 754.964Z",
    stroke: "url(#paint306_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.87 754.964L1259.25 769.608V798.897L1233.87 813.542L1208.49 798.897V769.608L1233.87 754.964Z",
    stroke: "url(#paint307_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.7 754.964L1321.08 769.608V798.897L1295.7 813.542L1270.32 798.897V769.608L1295.7 754.964Z",
    stroke: "url(#paint308_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 489.11L733.676 503.755V533.044L708.296 547.688L682.916 533.044V503.755L708.296 489.11Z",
    stroke: "url(#paint309_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 489.11L795.508 503.755V533.044L770.128 547.688L744.749 533.044V503.755L770.128 489.11Z",
    stroke: "url(#paint310_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 489.11L857.341 503.755V533.044L831.961 547.688L806.581 533.044V503.755L831.961 489.11Z",
    stroke: "url(#paint311_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 489.11L919.173 503.755V533.044L893.793 547.688L868.414 533.044V503.755L893.793 489.11Z",
    stroke: "url(#paint312_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 489.11L981.005 503.755V533.044L955.626 547.688L930.246 533.044V503.755L955.626 489.11Z",
    stroke: "url(#paint313_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 489.11L1042.84 503.755V533.044L1017.46 547.688L992.078 533.044V503.755L1017.46 489.11Z",
    stroke: "url(#paint314_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 489.11L1104.67 503.755V533.044L1079.29 547.688L1053.91 533.044V503.755L1079.29 489.11Z",
    stroke: "url(#paint315_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 489.11L1166.5 503.755V533.044L1141.12 547.688L1115.74 533.044V503.755L1141.12 489.11Z",
    stroke: "url(#paint316_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 489.11L1228.34 503.755V533.044L1202.96 547.688L1177.58 533.044V503.755L1202.96 489.11Z",
    stroke: "url(#paint317_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 489.11L1290.17 503.755V533.044L1264.79 547.688L1239.41 533.044V503.755L1264.79 489.11Z",
    stroke: "url(#paint318_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 489.11L1352 503.755V533.044L1326.62 547.688L1301.24 533.044V503.755L1326.62 489.11Z",
    stroke: "url(#paint319_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 595.323L733.676 609.968V639.256L708.296 653.901L682.916 639.256V609.968L708.296 595.323Z",
    stroke: "url(#paint320_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 595.323L795.508 609.968V639.256L770.128 653.901L744.749 639.256V609.968L770.128 595.323Z",
    stroke: "url(#paint321_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 595.323L857.341 609.968V639.256L831.961 653.901L806.581 639.256V609.968L831.961 595.323Z",
    stroke: "url(#paint322_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 595.323L919.173 609.968V639.256L893.793 653.901L868.414 639.256V609.968L893.793 595.323Z",
    stroke: "url(#paint323_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 595.323L981.005 609.968V639.256L955.626 653.901L930.246 639.256V609.968L955.626 595.323Z",
    stroke: "url(#paint324_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 595.323L1042.84 609.968V639.256L1017.46 653.901L992.078 639.256V609.968L1017.46 595.323Z",
    stroke: "url(#paint325_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 595.323L1104.67 609.968V639.256L1079.29 653.901L1053.91 639.256V609.968L1079.29 595.323Z",
    stroke: "url(#paint326_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 595.323L1166.5 609.968V639.256L1141.12 653.901L1115.74 639.256V609.968L1141.12 595.323Z",
    stroke: "url(#paint327_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 595.323L1228.34 609.968V639.256L1202.96 653.901L1177.58 639.256V609.968L1202.96 595.323Z",
    stroke: "url(#paint328_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 595.323L1290.17 609.968V639.256L1264.79 653.901L1239.41 639.256V609.968L1264.79 595.323Z",
    stroke: "url(#paint329_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 595.323L1352 609.968V639.256L1326.62 653.901L1301.24 639.256V609.968L1326.62 595.323Z",
    stroke: "url(#paint330_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 701.536L733.676 716.18V745.469L708.296 760.114L682.916 745.469V716.18L708.296 701.536Z",
    stroke: "url(#paint331_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 701.536L795.508 716.18V745.469L770.128 760.114L744.749 745.469V716.18L770.128 701.536Z",
    stroke: "url(#paint332_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 701.536L857.341 716.18V745.469L831.961 760.114L806.581 745.469V716.18L831.961 701.536Z",
    stroke: "url(#paint333_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 701.536L919.173 716.18V745.469L893.793 760.114L868.414 745.469V716.18L893.793 701.536Z",
    stroke: "url(#paint334_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 701.536L981.005 716.18V745.469L955.626 760.114L930.246 745.469V716.18L955.626 701.536Z",
    stroke: "url(#paint335_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 701.536L1042.84 716.18V745.469L1017.46 760.114L992.078 745.469V716.18L1017.46 701.536Z",
    stroke: "url(#paint336_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 701.536L1104.67 716.18V745.469L1079.29 760.114L1053.91 745.469V716.18L1079.29 701.536Z",
    stroke: "url(#paint337_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 701.536L1166.5 716.18V745.469L1141.12 760.114L1115.74 745.469V716.18L1141.12 701.536Z",
    stroke: "url(#paint338_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 701.536L1228.34 716.18V745.469L1202.96 760.114L1177.58 745.469V716.18L1202.96 701.536Z",
    stroke: "url(#paint339_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 701.536L1290.17 716.18V745.469L1264.79 760.114L1239.41 745.469V716.18L1264.79 701.536Z",
    stroke: "url(#paint340_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 701.536L1352 716.18V745.469L1326.62 760.114L1301.24 745.469V716.18L1326.62 701.536Z",
    stroke: "url(#paint341_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.296 807.748L733.676 822.393V851.682L708.296 866.326L682.916 851.682V822.393L708.296 807.748Z",
    stroke: "url(#paint342_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.128 807.748L795.508 822.393V851.682L770.128 866.326L744.749 851.682V822.393L770.128 807.748Z",
    stroke: "url(#paint343_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.961 807.748L857.341 822.393V851.682L831.961 866.326L806.581 851.682V822.393L831.961 807.748Z",
    stroke: "url(#paint344_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.793 807.748L919.173 822.393V851.682L893.793 866.326L868.414 851.682V822.393L893.793 807.748Z",
    stroke: "url(#paint345_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.626 807.748L981.005 822.393V851.682L955.626 866.326L930.246 851.682V822.393L955.626 807.748Z",
    stroke: "url(#paint346_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.46 807.748L1042.84 822.393V851.682L1017.46 866.326L992.078 851.682V822.393L1017.46 807.748Z",
    stroke: "url(#paint347_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.29 807.748L1104.67 822.393V851.682L1079.29 866.326L1053.91 851.682V822.393L1079.29 807.748Z",
    stroke: "url(#paint348_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.12 807.748L1166.5 822.393V851.682L1141.12 866.326L1115.74 851.682V822.393L1141.12 807.748Z",
    stroke: "url(#paint349_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.96 807.748L1228.34 822.393V851.682L1202.96 866.326L1177.58 851.682V822.393L1202.96 807.748Z",
    stroke: "url(#paint350_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.79 807.748L1290.17 822.393V851.682L1264.79 866.326L1239.41 851.682V822.393L1264.79 807.748Z",
    stroke: "url(#paint351_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.62 807.748L1352 822.393V851.682L1326.62 866.326L1301.24 851.682V822.393L1326.62 807.748Z",
    stroke: "url(#paint352_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 6.32617L1381.76 20.9706V50.2595L1356.38 64.904L1331 50.2595V20.9706L1356.38 6.32617Z",
    stroke: "url(#paint353_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 6.32617L1443.59 20.9706V50.2595L1418.21 64.904L1392.83 50.2595V20.9706L1418.21 6.32617Z",
    stroke: "url(#paint354_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 6.32617L1505.42 20.9706V50.2595L1480.04 64.904L1454.66 50.2595V20.9706L1480.04 6.32617Z",
    stroke: "url(#paint355_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 6.32617L1567.26 20.9706V50.2595L1541.88 64.904L1516.5 50.2595V20.9706L1541.88 6.32617Z",
    stroke: "url(#paint356_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 6.32617L1629.09 20.9706V50.2595L1603.71 64.904L1578.33 50.2595V20.9706L1603.71 6.32617Z",
    stroke: "url(#paint357_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 6.32617L1690.92 20.9706V50.2595L1665.54 64.904L1640.16 50.2595V20.9706L1665.54 6.32617Z",
    stroke: "url(#paint358_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 6.32617L1752.75 20.9706V50.2595L1727.37 64.904L1701.99 50.2595V20.9706L1727.37 6.32617Z",
    stroke: "url(#paint359_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 6.32617L1814.59 20.9706V50.2595L1789.21 64.904L1763.83 50.2595V20.9706L1789.21 6.32617Z",
    stroke: "url(#paint360_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 6.32617L1876.42 20.9706V50.2595L1851.04 64.904L1825.66 50.2595V20.9706L1851.04 6.32617Z",
    stroke: "url(#paint361_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 6.32617L1938.25 20.9706V50.2595L1912.87 64.904L1887.49 50.2595V20.9706L1912.87 6.32617Z",
    stroke: "url(#paint362_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 6.32617L2000.08 20.9706V50.2595L1974.7 64.904L1949.32 50.2595V20.9706L1974.7 6.32617Z",
    stroke: "url(#paint363_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 112.539L1381.76 127.183V156.472L1356.38 171.117L1331 156.472V127.183L1356.38 112.539Z",
    stroke: "url(#paint364_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 112.539L1443.59 127.183V156.472L1418.21 171.117L1392.83 156.472V127.183L1418.21 112.539Z",
    stroke: "url(#paint365_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 112.539L1505.42 127.183V156.472L1480.04 171.117L1454.66 156.472V127.183L1480.04 112.539Z",
    stroke: "url(#paint366_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 112.539L1567.26 127.183V156.472L1541.88 171.117L1516.5 156.472V127.183L1541.88 112.539Z",
    stroke: "url(#paint367_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 112.539L1629.09 127.183V156.472L1603.71 171.117L1578.33 156.472V127.183L1603.71 112.539Z",
    stroke: "url(#paint368_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 112.539L1690.92 127.183V156.472L1665.54 171.117L1640.16 156.472V127.183L1665.54 112.539Z",
    stroke: "url(#paint369_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 112.539L1752.75 127.183V156.472L1727.37 171.117L1701.99 156.472V127.183L1727.37 112.539Z",
    stroke: "url(#paint370_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 112.539L1814.59 127.183V156.472L1789.21 171.117L1763.83 156.472V127.183L1789.21 112.539Z",
    stroke: "url(#paint371_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 112.539L1876.42 127.183V156.472L1851.04 171.117L1825.66 156.472V127.183L1851.04 112.539Z",
    stroke: "url(#paint372_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 112.539L1938.25 127.183V156.472L1912.87 171.117L1887.49 156.472V127.183L1912.87 112.539Z",
    stroke: "url(#paint373_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 112.539L2000.08 127.183V156.472L1974.7 171.117L1949.32 156.472V127.183L1974.7 112.539Z",
    stroke: "url(#paint374_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 218.751L1381.76 233.396V262.685L1356.38 277.329L1331 262.685V233.396L1356.38 218.751Z",
    stroke: "url(#paint375_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 218.751L1443.59 233.396V262.685L1418.21 277.329L1392.83 262.685V233.396L1418.21 218.751Z",
    stroke: "url(#paint376_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 218.751L1505.42 233.396V262.685L1480.04 277.329L1454.66 262.685V233.396L1480.04 218.751Z",
    stroke: "url(#paint377_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 218.751L1567.26 233.396V262.685L1541.88 277.329L1516.5 262.685V233.396L1541.88 218.751Z",
    stroke: "url(#paint378_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 218.751L1629.09 233.396V262.685L1603.71 277.329L1578.33 262.685V233.396L1603.71 218.751Z",
    stroke: "url(#paint379_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 218.751L1690.92 233.396V262.685L1665.54 277.329L1640.16 262.685V233.396L1665.54 218.751Z",
    stroke: "url(#paint380_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 218.751L1752.75 233.396V262.685L1727.37 277.329L1701.99 262.685V233.396L1727.37 218.751Z",
    stroke: "url(#paint381_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 218.751L1814.59 233.396V262.685L1789.21 277.329L1763.83 262.685V233.396L1789.21 218.751Z",
    stroke: "url(#paint382_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 218.751L1876.42 233.396V262.685L1851.04 277.329L1825.66 262.685V233.396L1851.04 218.751Z",
    stroke: "url(#paint383_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 218.751L1938.25 233.396V262.685L1912.87 277.329L1887.49 262.685V233.396L1912.87 218.751Z",
    stroke: "url(#paint384_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 218.751L2000.08 233.396V262.685L1974.7 277.329L1949.32 262.685V233.396L1974.7 218.751Z",
    stroke: "url(#paint385_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 324.964L1381.76 339.608V368.897L1356.38 383.542L1331 368.897V339.608L1356.38 324.964Z",
    stroke: "url(#paint386_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 324.964L1443.59 339.608V368.897L1418.21 383.542L1392.83 368.897V339.608L1418.21 324.964Z",
    stroke: "url(#paint387_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 324.964L1505.42 339.608V368.897L1480.04 383.542L1454.66 368.897V339.608L1480.04 324.964Z",
    stroke: "url(#paint388_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 324.964L1567.26 339.608V368.897L1541.88 383.542L1516.5 368.897V339.608L1541.88 324.964Z",
    stroke: "url(#paint389_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 324.964L1629.09 339.608V368.897L1603.71 383.542L1578.33 368.897V339.608L1603.71 324.964Z",
    stroke: "url(#paint390_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 324.964L1690.92 339.608V368.897L1665.54 383.542L1640.16 368.897V339.608L1665.54 324.964Z",
    stroke: "url(#paint391_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 324.964L1752.75 339.608V368.897L1727.37 383.542L1701.99 368.897V339.608L1727.37 324.964Z",
    stroke: "url(#paint392_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 324.964L1814.59 339.608V368.897L1789.21 383.542L1763.83 368.897V339.608L1789.21 324.964Z",
    stroke: "url(#paint393_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 324.964L1876.42 339.608V368.897L1851.04 383.542L1825.66 368.897V339.608L1851.04 324.964Z",
    stroke: "url(#paint394_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 324.964L1938.25 339.608V368.897L1912.87 383.542L1887.49 368.897V339.608L1912.87 324.964Z",
    stroke: "url(#paint395_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 324.964L2000.08 339.608V368.897L1974.7 383.542L1949.32 368.897V339.608L1974.7 324.964Z",
    stroke: "url(#paint396_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 59.1105L1412.68 73.7549V103.044L1387.3 117.688L1361.92 103.044V73.7549L1387.3 59.1105Z",
    stroke: "url(#paint397_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 59.1105L1474.51 73.7549V103.044L1449.13 117.688L1423.75 103.044V73.7549L1449.13 59.1105Z",
    stroke: "url(#paint398_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 59.1105L1536.34 73.7549V103.044L1510.96 117.688L1485.58 103.044V73.7549L1510.96 59.1105Z",
    stroke: "url(#paint399_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 59.1105L1598.17 73.7549V103.044L1572.79 117.688L1547.41 103.044V73.7549L1572.79 59.1105Z",
    stroke: "url(#paint400_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 59.1105L1660.01 73.7549V103.044L1634.63 117.688L1609.25 103.044V73.7549L1634.63 59.1105Z",
    stroke: "url(#paint401_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 59.1105L1721.84 73.7549V103.044L1696.46 117.688L1671.08 103.044V73.7549L1696.46 59.1105Z",
    stroke: "url(#paint402_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 59.1105L1783.67 73.7549V103.044L1758.29 117.688L1732.91 103.044V73.7549L1758.29 59.1105Z",
    stroke: "url(#paint403_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 59.1105L1845.5 73.7549V103.044L1820.12 117.688L1794.74 103.044V73.7549L1820.12 59.1105Z",
    stroke: "url(#paint404_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 59.1105L1907.34 73.7549V103.044L1881.96 117.688L1856.58 103.044V73.7549L1881.96 59.1105Z",
    stroke: "url(#paint405_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 59.1105L1969.17 73.7549V103.044L1943.79 117.688L1918.41 103.044V73.7549L1943.79 59.1105Z",
    stroke: "url(#paint406_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 59.1105L2031 73.7549V103.044L2005.62 117.688L1980.24 103.044V73.7549L2005.62 59.1105Z",
    stroke: "url(#paint407_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 165.323L1412.68 179.968V209.256L1387.3 223.901L1361.92 209.256V179.968L1387.3 165.323Z",
    stroke: "url(#paint408_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 165.323L1474.51 179.968V209.256L1449.13 223.901L1423.75 209.256V179.968L1449.13 165.323Z",
    stroke: "url(#paint409_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 165.323L1536.34 179.968V209.256L1510.96 223.901L1485.58 209.256V179.968L1510.96 165.323Z",
    stroke: "url(#paint410_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 165.323L1598.17 179.968V209.256L1572.79 223.901L1547.41 209.256V179.968L1572.79 165.323Z",
    stroke: "url(#paint411_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 165.323L1660.01 179.968V209.256L1634.63 223.901L1609.25 209.256V179.968L1634.63 165.323Z",
    stroke: "url(#paint412_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 165.323L1721.84 179.968V209.256L1696.46 223.901L1671.08 209.256V179.968L1696.46 165.323Z",
    stroke: "url(#paint413_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 165.323L1783.67 179.968V209.256L1758.29 223.901L1732.91 209.256V179.968L1758.29 165.323Z",
    stroke: "url(#paint414_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 165.323L1845.5 179.968V209.256L1820.12 223.901L1794.74 209.256V179.968L1820.12 165.323Z",
    stroke: "url(#paint415_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 165.323L1907.34 179.968V209.256L1881.96 223.901L1856.58 209.256V179.968L1881.96 165.323Z",
    stroke: "url(#paint416_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 165.323L1969.17 179.968V209.256L1943.79 223.901L1918.41 209.256V179.968L1943.79 165.323Z",
    stroke: "url(#paint417_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 165.323L2031 179.968V209.256L2005.62 223.901L1980.24 209.256V179.968L2005.62 165.323Z",
    stroke: "url(#paint418_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 271.536L1412.68 286.18V315.469L1387.3 330.113L1361.92 315.469V286.18L1387.3 271.536Z",
    stroke: "url(#paint419_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 271.536L1474.51 286.18V315.469L1449.13 330.113L1423.75 315.469V286.18L1449.13 271.536Z",
    stroke: "url(#paint420_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 271.536L1536.34 286.18V315.469L1510.96 330.113L1485.58 315.469V286.18L1510.96 271.536Z",
    stroke: "url(#paint421_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 271.536L1598.17 286.18V315.469L1572.79 330.113L1547.41 315.469V286.18L1572.79 271.536Z",
    stroke: "url(#paint422_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 271.536L1660.01 286.18V315.469L1634.63 330.113L1609.25 315.469V286.18L1634.63 271.536Z",
    stroke: "url(#paint423_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 271.536L1721.84 286.18V315.469L1696.46 330.113L1671.08 315.469V286.18L1696.46 271.536Z",
    stroke: "url(#paint424_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 271.536L1783.67 286.18V315.469L1758.29 330.113L1732.91 315.469V286.18L1758.29 271.536Z",
    stroke: "url(#paint425_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 271.536L1845.5 286.18V315.469L1820.12 330.113L1794.74 315.469V286.18L1820.12 271.536Z",
    stroke: "url(#paint426_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 271.536L1907.34 286.18V315.469L1881.96 330.113L1856.58 315.469V286.18L1881.96 271.536Z",
    stroke: "url(#paint427_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 271.536L1969.17 286.18V315.469L1943.79 330.113L1918.41 315.469V286.18L1943.79 271.536Z",
    stroke: "url(#paint428_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 271.536L2031 286.18V315.469L2005.62 330.113L1980.24 315.469V286.18L2005.62 271.536Z",
    stroke: "url(#paint429_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 377.748L1412.68 392.393V421.682L1387.3 436.326L1361.92 421.682V392.393L1387.3 377.748Z",
    stroke: "url(#paint430_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 377.748L1474.51 392.393V421.682L1449.13 436.326L1423.75 421.682V392.393L1449.13 377.748Z",
    stroke: "url(#paint431_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 377.748L1536.34 392.393V421.682L1510.96 436.326L1485.58 421.682V392.393L1510.96 377.748Z",
    stroke: "url(#paint432_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 377.748L1598.17 392.393V421.682L1572.79 436.326L1547.41 421.682V392.393L1572.79 377.748Z",
    stroke: "url(#paint433_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 377.748L1660.01 392.393V421.682L1634.63 436.326L1609.25 421.682V392.393L1634.63 377.748Z",
    stroke: "url(#paint434_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 377.748L1721.84 392.393V421.682L1696.46 436.326L1671.08 421.682V392.393L1696.46 377.748Z",
    stroke: "url(#paint435_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 377.748L1783.67 392.393V421.682L1758.29 436.326L1732.91 421.682V392.393L1758.29 377.748Z",
    stroke: "url(#paint436_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 377.748L1845.5 392.393V421.682L1820.12 436.326L1794.74 421.682V392.393L1820.12 377.748Z",
    stroke: "url(#paint437_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 377.748L1907.34 392.393V421.682L1881.96 436.326L1856.58 421.682V392.393L1881.96 377.748Z",
    stroke: "url(#paint438_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 377.748L1969.17 392.393V421.682L1943.79 436.326L1918.41 421.682V392.393L1943.79 377.748Z",
    stroke: "url(#paint439_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 377.748L2031 392.393V421.682L2005.62 436.326L1980.24 421.682V392.393L2005.62 377.748Z",
    stroke: "url(#paint440_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 436.326L1381.76 450.971V480.26L1356.38 494.904L1331 480.26V450.971L1356.38 436.326Z",
    stroke: "url(#paint441_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 436.326L1443.59 450.971V480.26L1418.21 494.904L1392.83 480.26V450.971L1418.21 436.326Z",
    stroke: "url(#paint442_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 436.326L1505.42 450.971V480.26L1480.04 494.904L1454.66 480.26V450.971L1480.04 436.326Z",
    stroke: "url(#paint443_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 436.326L1567.26 450.971V480.26L1541.88 494.904L1516.5 480.26V450.971L1541.88 436.326Z",
    stroke: "url(#paint444_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 436.326L1629.09 450.971V480.26L1603.71 494.904L1578.33 480.26V450.971L1603.71 436.326Z",
    stroke: "url(#paint445_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 436.326L1690.92 450.971V480.26L1665.54 494.904L1640.16 480.26V450.971L1665.54 436.326Z",
    stroke: "url(#paint446_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 436.326L1752.75 450.971V480.26L1727.37 494.904L1701.99 480.26V450.971L1727.37 436.326Z",
    stroke: "url(#paint447_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 436.326L1814.59 450.971V480.26L1789.21 494.904L1763.83 480.26V450.971L1789.21 436.326Z",
    stroke: "url(#paint448_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 436.326L1876.42 450.971V480.26L1851.04 494.904L1825.66 480.26V450.971L1851.04 436.326Z",
    stroke: "url(#paint449_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 436.326L1938.25 450.971V480.26L1912.87 494.904L1887.49 480.26V450.971L1912.87 436.326Z",
    stroke: "url(#paint450_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 436.326L2000.08 450.971V480.26L1974.7 494.904L1949.32 480.26V450.971L1974.7 436.326Z",
    stroke: "url(#paint451_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 542.539L1381.76 557.183V586.472L1356.38 601.117L1331 586.472V557.183L1356.38 542.539Z",
    stroke: "url(#paint452_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 542.539L1443.59 557.183V586.472L1418.21 601.117L1392.83 586.472V557.183L1418.21 542.539Z",
    stroke: "url(#paint453_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 542.539L1505.42 557.183V586.472L1480.04 601.117L1454.66 586.472V557.183L1480.04 542.539Z",
    stroke: "url(#paint454_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 542.539L1567.26 557.183V586.472L1541.88 601.117L1516.5 586.472V557.183L1541.88 542.539Z",
    stroke: "url(#paint455_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 542.539L1629.09 557.183V586.472L1603.71 601.117L1578.33 586.472V557.183L1603.71 542.539Z",
    stroke: "url(#paint456_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 542.539L1690.92 557.183V586.472L1665.54 601.117L1640.16 586.472V557.183L1665.54 542.539Z",
    stroke: "url(#paint457_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 542.539L1752.75 557.183V586.472L1727.37 601.117L1701.99 586.472V557.183L1727.37 542.539Z",
    stroke: "url(#paint458_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 542.539L1814.59 557.183V586.472L1789.21 601.117L1763.83 586.472V557.183L1789.21 542.539Z",
    stroke: "url(#paint459_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 542.539L1876.42 557.183V586.472L1851.04 601.117L1825.66 586.472V557.183L1851.04 542.539Z",
    stroke: "url(#paint460_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 542.539L1938.25 557.183V586.472L1912.87 601.117L1887.49 586.472V557.183L1912.87 542.539Z",
    stroke: "url(#paint461_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 542.539L2000.08 557.183V586.472L1974.7 601.117L1949.32 586.472V557.183L1974.7 542.539Z",
    stroke: "url(#paint462_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 648.751L1381.76 663.396V692.685L1356.38 707.329L1331 692.685V663.396L1356.38 648.751Z",
    stroke: "url(#paint463_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 648.751L1443.59 663.396V692.685L1418.21 707.329L1392.83 692.685V663.396L1418.21 648.751Z",
    stroke: "url(#paint464_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 648.751L1505.42 663.396V692.685L1480.04 707.329L1454.66 692.685V663.396L1480.04 648.751Z",
    stroke: "url(#paint465_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 648.751L1567.26 663.396V692.685L1541.88 707.329L1516.5 692.685V663.396L1541.88 648.751Z",
    stroke: "url(#paint466_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 648.751L1629.09 663.396V692.685L1603.71 707.329L1578.33 692.685V663.396L1603.71 648.751Z",
    stroke: "url(#paint467_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 648.751L1690.92 663.396V692.685L1665.54 707.329L1640.16 692.685V663.396L1665.54 648.751Z",
    stroke: "url(#paint468_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 648.751L1752.75 663.396V692.685L1727.37 707.329L1701.99 692.685V663.396L1727.37 648.751Z",
    stroke: "url(#paint469_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 648.751L1814.59 663.396V692.685L1789.21 707.329L1763.83 692.685V663.396L1789.21 648.751Z",
    stroke: "url(#paint470_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 648.751L1876.42 663.396V692.685L1851.04 707.329L1825.66 692.685V663.396L1851.04 648.751Z",
    stroke: "url(#paint471_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 648.751L1938.25 663.396V692.685L1912.87 707.329L1887.49 692.685V663.396L1912.87 648.751Z",
    stroke: "url(#paint472_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 648.751L2000.08 663.396V692.685L1974.7 707.329L1949.32 692.685V663.396L1974.7 648.751Z",
    stroke: "url(#paint473_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.38 754.964L1381.76 769.608V798.897L1356.38 813.542L1331 798.897V769.608L1356.38 754.964Z",
    stroke: "url(#paint474_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.21 754.964L1443.59 769.608V798.897L1418.21 813.542L1392.83 798.897V769.608L1418.21 754.964Z",
    stroke: "url(#paint475_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.04 754.964L1505.42 769.608V798.897L1480.04 813.542L1454.66 798.897V769.608L1480.04 754.964Z",
    stroke: "url(#paint476_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.88 754.964L1567.26 769.608V798.897L1541.88 813.542L1516.5 798.897V769.608L1541.88 754.964Z",
    stroke: "url(#paint477_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.71 754.964L1629.09 769.608V798.897L1603.71 813.542L1578.33 798.897V769.608L1603.71 754.964Z",
    stroke: "url(#paint478_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.54 754.964L1690.92 769.608V798.897L1665.54 813.542L1640.16 798.897V769.608L1665.54 754.964Z",
    stroke: "url(#paint479_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.37 754.964L1752.75 769.608V798.897L1727.37 813.542L1701.99 798.897V769.608L1727.37 754.964Z",
    stroke: "url(#paint480_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.21 754.964L1814.59 769.608V798.897L1789.21 813.542L1763.83 798.897V769.608L1789.21 754.964Z",
    stroke: "url(#paint481_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.04 754.964L1876.42 769.608V798.897L1851.04 813.542L1825.66 798.897V769.608L1851.04 754.964Z",
    stroke: "url(#paint482_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87 754.964L1938.25 769.608V798.897L1912.87 813.542L1887.49 798.897V769.608L1912.87 754.964Z",
    stroke: "url(#paint483_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.7 754.964L2000.08 769.608V798.897L1974.7 813.542L1949.32 798.897V769.608L1974.7 754.964Z",
    stroke: "url(#paint484_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 489.11L1412.68 503.755V533.044L1387.3 547.688L1361.92 533.044V503.755L1387.3 489.11Z",
    stroke: "url(#paint485_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 489.11L1474.51 503.755V533.044L1449.13 547.688L1423.75 533.044V503.755L1449.13 489.11Z",
    stroke: "url(#paint486_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 489.11L1536.34 503.755V533.044L1510.96 547.688L1485.58 533.044V503.755L1510.96 489.11Z",
    stroke: "url(#paint487_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 489.11L1598.17 503.755V533.044L1572.79 547.688L1547.41 533.044V503.755L1572.79 489.11Z",
    stroke: "url(#paint488_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 489.11L1660.01 503.755V533.044L1634.63 547.688L1609.25 533.044V503.755L1634.63 489.11Z",
    stroke: "url(#paint489_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 489.11L1721.84 503.755V533.044L1696.46 547.688L1671.08 533.044V503.755L1696.46 489.11Z",
    stroke: "url(#paint490_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 489.11L1783.67 503.755V533.044L1758.29 547.688L1732.91 533.044V503.755L1758.29 489.11Z",
    stroke: "url(#paint491_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 489.11L1845.5 503.755V533.044L1820.12 547.688L1794.74 533.044V503.755L1820.12 489.11Z",
    stroke: "url(#paint492_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 489.11L1907.34 503.755V533.044L1881.96 547.688L1856.58 533.044V503.755L1881.96 489.11Z",
    stroke: "url(#paint493_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 489.11L1969.17 503.755V533.044L1943.79 547.688L1918.41 533.044V503.755L1943.79 489.11Z",
    stroke: "url(#paint494_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 489.11L2031 503.755V533.044L2005.62 547.688L1980.24 533.044V503.755L2005.62 489.11Z",
    stroke: "url(#paint495_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 595.323L1412.68 609.968V639.256L1387.3 653.901L1361.92 639.256V609.968L1387.3 595.323Z",
    stroke: "url(#paint496_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 595.323L1474.51 609.968V639.256L1449.13 653.901L1423.75 639.256V609.968L1449.13 595.323Z",
    stroke: "url(#paint497_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 595.323L1536.34 609.968V639.256L1510.96 653.901L1485.58 639.256V609.968L1510.96 595.323Z",
    stroke: "url(#paint498_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 595.323L1598.17 609.968V639.256L1572.79 653.901L1547.41 639.256V609.968L1572.79 595.323Z",
    stroke: "url(#paint499_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 595.323L1660.01 609.968V639.256L1634.63 653.901L1609.25 639.256V609.968L1634.63 595.323Z",
    stroke: "url(#paint500_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 595.323L1721.84 609.968V639.256L1696.46 653.901L1671.08 639.256V609.968L1696.46 595.323Z",
    stroke: "url(#paint501_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 595.323L1783.67 609.968V639.256L1758.29 653.901L1732.91 639.256V609.968L1758.29 595.323Z",
    stroke: "url(#paint502_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 595.323L1845.5 609.968V639.256L1820.12 653.901L1794.74 639.256V609.968L1820.12 595.323Z",
    stroke: "url(#paint503_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 595.323L1907.34 609.968V639.256L1881.96 653.901L1856.58 639.256V609.968L1881.96 595.323Z",
    stroke: "url(#paint504_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 595.323L1969.17 609.968V639.256L1943.79 653.901L1918.41 639.256V609.968L1943.79 595.323Z",
    stroke: "url(#paint505_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 595.323L2031 609.968V639.256L2005.62 653.901L1980.24 639.256V609.968L2005.62 595.323Z",
    stroke: "url(#paint506_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 701.536L1412.68 716.18V745.469L1387.3 760.114L1361.92 745.469V716.18L1387.3 701.536Z",
    stroke: "url(#paint507_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 701.536L1474.51 716.18V745.469L1449.13 760.114L1423.75 745.469V716.18L1449.13 701.536Z",
    stroke: "url(#paint508_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 701.536L1536.34 716.18V745.469L1510.96 760.114L1485.58 745.469V716.18L1510.96 701.536Z",
    stroke: "url(#paint509_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 701.536L1598.17 716.18V745.469L1572.79 760.114L1547.41 745.469V716.18L1572.79 701.536Z",
    stroke: "url(#paint510_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 701.536L1660.01 716.18V745.469L1634.63 760.114L1609.25 745.469V716.18L1634.63 701.536Z",
    stroke: "url(#paint511_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 701.536L1721.84 716.18V745.469L1696.46 760.114L1671.08 745.469V716.18L1696.46 701.536Z",
    stroke: "url(#paint512_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 701.536L1783.67 716.18V745.469L1758.29 760.114L1732.91 745.469V716.18L1758.29 701.536Z",
    stroke: "url(#paint513_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 701.536L1845.5 716.18V745.469L1820.12 760.114L1794.74 745.469V716.18L1820.12 701.536Z",
    stroke: "url(#paint514_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 701.536L1907.34 716.18V745.469L1881.96 760.114L1856.58 745.469V716.18L1881.96 701.536Z",
    stroke: "url(#paint515_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 701.536L1969.17 716.18V745.469L1943.79 760.114L1918.41 745.469V716.18L1943.79 701.536Z",
    stroke: "url(#paint516_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 701.536L2031 716.18V745.469L2005.62 760.114L1980.24 745.469V716.18L2005.62 701.536Z",
    stroke: "url(#paint517_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.3 807.748L1412.68 822.393V851.682L1387.3 866.326L1361.92 851.682V822.393L1387.3 807.748Z",
    stroke: "url(#paint518_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.13 807.748L1474.51 822.393V851.682L1449.13 866.326L1423.75 851.682V822.393L1449.13 807.748Z",
    stroke: "url(#paint519_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.96 807.748L1536.34 822.393V851.682L1510.96 866.326L1485.58 851.682V822.393L1510.96 807.748Z",
    stroke: "url(#paint520_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.79 807.748L1598.17 822.393V851.682L1572.79 866.326L1547.41 851.682V822.393L1572.79 807.748Z",
    stroke: "url(#paint521_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.63 807.748L1660.01 822.393V851.682L1634.63 866.326L1609.25 851.682V822.393L1634.63 807.748Z",
    stroke: "url(#paint522_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.46 807.748L1721.84 822.393V851.682L1696.46 866.326L1671.08 851.682V822.393L1696.46 807.748Z",
    stroke: "url(#paint523_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.29 807.748L1783.67 822.393V851.682L1758.29 866.326L1732.91 851.682V822.393L1758.29 807.748Z",
    stroke: "url(#paint524_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820.12 807.748L1845.5 822.393V851.682L1820.12 866.326L1794.74 851.682V822.393L1820.12 807.748Z",
    stroke: "url(#paint525_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.96 807.748L1907.34 822.393V851.682L1881.96 866.326L1856.58 851.682V822.393L1881.96 807.748Z",
    stroke: "url(#paint526_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.79 807.748L1969.17 822.393V851.682L1943.79 866.326L1918.41 851.682V822.393L1943.79 807.748Z",
    stroke: "url(#paint527_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.62 807.748L2031 822.393V851.682L2005.62 866.326L1980.24 851.682V822.393L2005.62 807.748Z",
    stroke: "url(#paint528_linear_140_2)",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_140_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2345 1203V759C2336.32 751.557 2327.87 743.971 2319.85 735.82C2318 734.004 2316.09 732.31 2314.12 730.625C2310.93 727.884 2307.96 724.993 2305 722C2302.08 719.048 2299.15 716.196 2296 713.5C2292.11 710.174 2288.54 706.563 2284.95 702.925L2284.95 702.921L2284.95 702.921L2284.95 702.92L2284.94 702.919L2284.94 702.919L2284.94 702.918L2284.44 702.41C2281.73 699.731 2278.89 697.254 2276 694.777C2273.74 692.767 2271.62 690.652 2269.5 688.5C2266.79 685.755 2264.06 683.127 2261.12 680.625C2257.24 677.296 2253.66 673.691 2250.07 670.052C2246.83 666.78 2243.46 663.731 2239.96 660.742C2237.34 658.412 2234.89 655.917 2232.43 653.418C2232.02 653.006 2231.62 652.595 2231.21 652.184C2229.22 650.22 2227.19 648.379 2225.06 646.562C2221.89 643.844 2218.94 640.972 2216 638C2213.08 635.048 2210.15 632.196 2207 629.5C2203.11 626.172 2199.54 622.559 2195.94 618.919L2195.44 618.406C2192.75 615.753 2189.94 613.303 2187.07 610.852C2184.57 608.618 2182.23 606.258 2179.88 603.875C2177.3 601.228 2176.01 599.907 2174.65 598.671C2173.29 597.439 2171.86 596.291 2169 594C2165.53 594.329 2163.89 595.765 2161.54 598.238L2159.61 600.225L2157.62 602.312C2153.34 606.799 2149.33 610.788 2144 614L2143.95 613.95C2138.29 607.678 2136.43 605.621 2134.59 603.541C2134.31 603.219 2134.03 602.896 2133.73 602.557C2133.09 601.831 2132.4 601.03 2131.5 600C2128.11 596.102 2124.64 592.267 2121.18 588.43C2119.31 586.344 2117.46 584.242 2115.62 582.125C2112.2 578.193 2108.67 574.361 2105.14 570.526L2105.05 570.422C2101.93 567.036 2098.89 563.601 2095.88 560.125C2093.32 557.232 2090.71 554.395 2088.09 551.558L2088.08 551.542L2087.04 550.42C2084.51 547.665 2082.01 544.893 2079.56 542.062C2075.7 537.605 2071.68 533.282 2067.67 528.959L2066.74 527.962C2066.34 527.528 2065.94 527.093 2065.53 526.658C2063.18 524.113 2060.84 521.557 2058.5 519C2053.69 513.744 2048.86 508.504 2044.02 503.27C2042.06 501.144 2040.09 499.017 2038.14 496.887C2032.35 490.601 2026.53 484.351 2020.69 478.125L2018.69 475.999C2015.66 472.778 2012.61 469.596 2009.46 466.492C2007.21 464.263 2005.1 461.98 2003.05 459.563C1998.41 454.23 1993.41 449.239 1988.41 444.245C1987.83 443.665 1987.25 443.085 1986.67 442.504L1983.08 438.904C1980.58 436.398 1978.08 433.895 1975.58 431.392C1972.4 428.213 1969.23 425.026 1966.05 421.838C1963.59 419.359 1961.11 416.885 1958.64 414.412C1957.47 413.241 1956.3 412.068 1955.13 410.893C1948.8 404.517 1942.41 398.471 1935.36 392.885C1933.12 391.098 1930.99 389.237 1928.88 387.312C1924.41 383.329 1922.21 381.371 1919.67 380.082C1917.22 378.837 1914.45 378.218 1909 377C1907.54 377.683 1906.77 378.045 1906.06 378.502C1905.26 379.016 1904.54 379.65 1903 380.998L1903 380.999L1903 381L1901.16 382.441C1894.21 388.145 1888.81 395.165 1883.5 402.375L1882.26 404.05C1881.12 405.614 1879.98 407.188 1878.85 408.762L1877 411H1875L1874.7 410.661L1874.57 410.516C1874.26 410.166 1874.04 409.912 1873.82 409.651C1873.43 409.171 1873.07 408.669 1872.23 407.512L1870.56 405.211L1868.75 402.688C1867.47 400.928 1866.19 399.169 1864.91 397.41L1862.93 394.672C1860.02 390.642 1857.07 386.632 1854.12 382.625L1852.39 380.27C1847.33 373.402 1842.15 366.619 1836.97 359.843C1832.54 354.047 1828.18 348.201 1823.88 342.312C1818.74 335.3 1813.47 328.408 1808.12 321.567C1804.29 316.673 1800.53 311.734 1796.81 306.75C1791.77 299.982 1786.59 293.326 1781.35 286.709C1780 285.003 1778.66 283.292 1777.32 281.578C1770.81 273.239 1764.17 265.004 1757.48 256.809C1756.17 255.208 1754.87 253.604 1753.56 252C1745.44 240.401 1741.51 234.8 1736.78 229.994C1732.36 225.506 1727.23 221.713 1717.31 214.376L1717.31 214.375C1708.4 216.057 1701.44 222.797 1695.07 228.967C1694.71 229.313 1694.35 229.658 1694 230L1691.24 232.637C1685 238.733 1679.36 245.126 1674 252L1672.25 254.239C1668.15 259.481 1664.07 264.737 1660 270C1655.03 265.836 1650.37 261.5 1645.81 256.894L1643.72 254.797C1641.44 252.504 1639.16 250.207 1636.88 247.911L1636.85 247.881L1634.73 245.753L1631.9 242.908C1628.35 239.347 1624.81 235.785 1621.27 232.222C1615.67 226.593 1610.07 220.97 1604.47 215.348L1601.6 212.471L1597.25 208.113C1591.81 202.648 1586.36 197.182 1580.91 191.715L1579.41 190.202C1571.33 182.092 1563.26 173.974 1555.19 165.855C1546.9 157.514 1538.6 149.182 1530.29 140.859C1525.63 136.188 1520.97 131.511 1516.32 126.824C1511.96 122.423 1507.58 118.033 1503.2 113.653C1501.59 112.039 1499.98 110.421 1498.38 108.799C1496.2 106.594 1494.01 104.404 1491.81 102.217L1489.88 100.24L1489.88 100.239C1489.06 99.4075 1488.59 98.929 1488.09 98.4789C1487.42 97.8696 1486.7 97.3125 1485 96.0018L1485 96C1481.57 96.4238 1480.07 97.6178 1477.75 100.125C1475.36 102.626 1472.94 104.991 1470.31 107.25C1466.81 110.267 1463.4 113.369 1460 116.5L1459.93 116.563L1459.84 116.646L1459.8 116.68C1454.73 121.337 1453.2 122.747 1451.65 124.144C1450.99 124.742 1450.32 125.339 1449.38 126.188L1447.52 127.855C1446.78 128.415 1446.4 128.701 1445.97 128.847C1445.52 129 1445.02 129 1444 129L1442.69 126.608C1435.12 112.792 1427.54 98.9959 1419.46 85.4692C1417.67 82.4463 1415.91 79.4091 1414.14 76.3711C1405.64 61.7548 1396.97 47.2768 1387.9 33.002C1385.9 29.8459 1383.92 26.681 1381.93 23.5156C1374.79 12.194 1367.47 1.19867 1359.25 -9.36426C1357.58 -11.5438 1356.01 -13.7878 1354.44 -16.0341L1353.94 -16.75C1348.93 -23.6955 1343.05 -29.952 1337 -36C1330.98 -36 1327.11 -33.5154 1322.14 -30.2773C1320.96 -29.5736 1320.43 -29.2576 1319.86 -29.1157C1319.39 -29 1318.9 -29 1318 -29V-27C1317.33 -26.4206 1316.95 -26.084 1316.55 -25.7603C1316 -25.3114 1315.43 -24.8873 1314.06 -23.875C1308.87 -19.8355 1304.09 -15.454 1299.31 -10.9375L1297.15 -8.8999C1292.96 -4.93291 1290.86 -2.95012 1288.84 -0.899338C1286.81 1.14766 1284.86 3.26242 1280.95 7.48581L1280.94 7.49533L1280.94 7.5C1277.4 11.6051 1273.71 15.5498 1270 19.5C1265.23 24.5871 1260.53 29.6972 1256 35C1255.1 36.0445 1254.2 37.0888 1253.3 38.1328C1247.41 44.9852 1241.56 51.8675 1235.73 58.7734C1233.87 60.9703 1232.01 63.1625 1230.15 65.3516C1225.42 70.9101 1220.75 76.5027 1216.21 82.2227C1213.61 85.49 1210.97 88.7277 1208.33 91.9659L1208.33 91.9671L1208.32 91.9683L1208.32 91.9695L1208.32 91.9707L1208.32 91.9719L1208.32 91.9731L1208.32 91.9743L1208.32 91.9755L1208.32 91.9787L1208.31 91.9839L1207.69 92.75C1203.12 98.3566 1198.62 104.007 1194.17 109.708C1190.65 114.206 1187.05 118.639 1183.44 123.062C1178.75 128.812 1174.16 134.624 1169.66 140.523C1166.7 144.401 1163.7 148.248 1160.71 152.095L1160 153C1155.19 159.18 1150.4 165.376 1145.63 171.59C1143.09 174.896 1140.52 178.185 1137.96 181.474L1137.78 181.702C1132.63 188.303 1127.52 194.922 1122.52 201.637C1120.49 204.364 1118.42 207.068 1116.35 209.77C1109.36 218.902 1102.44 228.074 1095.75 237.432C1090.02 245.426 1084.02 253.217 1078 261C1072.5 257.094 1067.68 252.91 1063 248.062C1058.75 243.735 1054.49 239.557 1049.86 235.637C1047.64 233.681 1045.58 231.604 1043.5 229.5C1040.59 226.57 1037.67 223.67 1034.62 220.875L1032.73 219.117L1031 218C1027.63 219.124 1026.91 220.07 1024.91 222.689L1024.78 222.856L1024.62 223.062L1022.5 225.797L1021.31 227.334C1019.5 229.635 1017.65 231.898 1015.8 234.161L1015.79 234.169L1015.3 234.764C1009.92 241.337 1004.67 247.983 999.516 254.738C996.795 258.287 993.993 261.768 991.188 265.25C986.308 271.312 981.564 277.468 976.856 283.663C973.302 288.329 969.682 292.934 966 297.5C960.129 304.789 954.44 312.209 948.779 319.662C946.895 322.138 945.005 324.608 943.113 327.078C930.889 343.053 918.949 359.223 907.207 375.555C905.096 378.489 902.968 381.41 900.824 384.32C889.176 400.183 878.132 416.512 868.734 433.82C867.222 436.593 865.647 439.306 864 442C861.345 439.437 859.071 436.835 856.875 433.875C846.56 420.851 833.85 408.233 820 399L818.453 400.914C814.042 406.342 809.566 411.702 805 417C800.681 422.013 796.449 427.085 792.277 432.223C789.718 435.344 787.114 438.424 784.5 441.5C779.594 447.275 774.78 453.12 770 459C765.202 464.903 760.365 470.767 755.438 476.562C751.622 481.053 747.885 485.593 744.223 490.211C736.892 499.41 729.429 508.507 721.968 517.602L720.062 519.925L719.255 520.91C718.805 521.458 718.356 522.006 717.906 522.555C715.602 525.368 713.3 528.184 711 531L709.515 532.817C703.327 540.393 697.185 547.998 691.167 555.708C687.647 560.206 684.052 564.64 680.438 569.062C675.671 574.901 671.021 580.812 666.449 586.805C663.897 590.147 661.294 593.449 658.688 596.75C647.214 611.312 636.053 626.118 625 641L623.264 643.333C613.353 656.7 604.166 670.493 596 685C594.274 682.41 592.911 679.889 591.5 677.125C586.086 667.13 578.637 658.371 571 650C567.356 651.537 565.031 653.721 562.251 656.506L560.864 657.887C559.356 659.391 557.856 660.902 556.355 662.414C555.302 663.469 554.248 664.523 553.194 665.577C550.985 667.788 548.779 670.002 546.575 672.219C543.769 675.042 540.957 677.858 538.143 680.671C535.964 682.85 533.788 685.032 531.613 687.214C530.578 688.252 529.543 689.289 528.507 690.326C523.319 695.522 518.202 700.741 513.442 706.339C510.995 709.158 508.32 711.752 505.643 714.349L505.642 714.351C505.274 714.708 504.906 715.064 504.539 715.422C501.118 718.789 497.947 722.313 494.808 725.943C492.179 728.934 489.435 731.814 486.689 734.695L486.622 734.766C486.289 735.115 485.957 735.464 485.625 735.812C480.56 741.171 475.756 746.601 471.164 752.371C468.76 755.292 466.21 758.054 463.625 760.812C458.723 766.071 454.283 771.6 449.895 777.289C447.329 780.606 444.675 783.842 442.004 787.075C436.716 793.482 431.839 799.91 427.391 806.938L426 809H425V1203H2345ZM1821.91 724.296C1819.44 722.34 1816.97 720.393 1814.02 719.203C1813.01 719.102 1812.51 719.051 1812.03 719.145C1811.55 719.239 1811.1 719.479 1810.2 719.96L1808.35 721.484L1806.24 723.178C1804.75 724.391 1803.24 725.58 1801.71 726.744L1799.34 728.516L1797.49 729.909L1797.48 729.911C1791.12 734.705 1784.76 739.498 1778.27 744.109C1773.37 747.565 1768.55 751.08 1763.81 754.75C1760.79 757.109 1757.75 759.447 1754.66 761.723L1752.14 763.566C1751.47 764.054 1750.8 764.541 1750.13 765.028L1749.12 765.764C1748.42 766.28 1747.71 766.797 1747 767.312C1741.98 770.937 1737.23 774.456 1733 779C1740.09 782.068 1747.44 783.486 1754.99 784.933L1757.31 785.375C1772.32 788.278 1787.36 790.643 1802.51 792.684C1809.12 793.574 1815.68 794.59 1822.23 795.85C1818.87 798.645 1815.83 801.651 1813.46 804.954C1812.6 806.077 1811.83 807.347 1811 809H1870V806C1868.42 803.585 1866.59 801.236 1864.58 798.973C1868.21 798.803 1871.83 798.626 1875.45 798.436C1877.03 798.352 1878.61 798.269 1880.19 798.188C1881.77 798.114 1883.41 798.064 1885.07 798.013C1894.96 797.708 1905.94 797.37 1914 792C1909.48 788.792 1905 785.539 1900.55 782.244C1894.14 777.506 1887.73 772.788 1881.26 768.139C1874.11 763.005 1867.03 757.796 1860 752.5C1853.63 747.7 1847.23 742.962 1840.75 738.312L1840.54 738.163C1836.91 735.567 1833.29 732.973 1829.73 730.289L1827.46 728.559C1826.01 727.457 1824.57 726.354 1823.12 725.25C1822.97 725.127 1822.81 725.004 1822.65 724.88L1822.43 724.704C1822.26 724.568 1822.08 724.432 1821.91 724.296ZM781 712C785.773 712.459 789.243 714.736 793.081 717.255L793.144 717.296C793.34 717.424 793.536 717.553 793.734 717.682C793.864 717.767 793.994 717.852 794.125 717.938L796.576 719.511C799.393 721.328 802.198 723.162 805 725L808.334 727.186C811.875 729.51 815.407 731.847 818.938 734.188L820.638 735.312C831.112 742.243 841.546 749.35 850.75 757.938L852.32 759.354C853.59 760.524 854.801 761.757 856 763V765C850.414 765.813 845.035 766.107 839.405 766.008C844.097 769.715 848.536 774.321 852.03 778.971C853.53 780.931 854.865 782.977 856 785V787C852.649 787.751 849.553 788.126 846.121 788.129L843.269 788.139L840.223 788.133L837.059 788.136C834.854 788.136 832.649 788.135 830.445 788.13C827.078 788.125 823.712 788.13 820.346 788.137C818.201 788.136 816.055 788.135 813.91 788.133L810.87 788.139C806.133 788.123 801.657 787.988 797 787C797.347 786.117 797.747 785.318 798.193 784.58C801.256 779.258 806.717 774.868 812.221 771.025C808.147 771.158 804.074 771.297 800 771.438L796.301 771.557L792.688 771.684L789.387 771.795C787.726 771.875 786.861 771.917 786 772C785.064 772.09 784.134 772.227 782.193 772.513L782.191 772.514C777.538 773.125 772.937 773.126 768.25 773.098L765.527 773.093C764.015 773.09 762.504 773.086 760.993 773.08C760.196 773.076 759.399 773.073 758.603 773.07L757 773.062C755.777 773.059 754.555 773.056 753.332 773.054L751.184 773.049C746.456 773.038 741.728 773.021 737 773C738.132 769.332 739.304 766.164 741.434 762.969L742.884 760.783L744.438 758.5L746.052 756.105C751.036 748.795 756.404 741.848 762 735L764.336 732.113C769.676 725.546 775.104 719.052 780.533 712.559L781 712ZM1719.1 406.263L1719.1 406.262C1716.13 403.975 1713.18 401.709 1709.96 399.777C1695.08 393.873 1666.53 427.794 1660 438C1661.21 439.207 1662.2 440.197 1663.31 441.027C1668.36 444.809 1675.89 445.275 1717.75 447.864L1717.75 447.864L1720 448C1719.83 448.169 1719.69 448.312 1719.55 448.457C1719.03 448.987 1718.53 449.539 1716.91 451.43C1715.55 452.884 1714.24 454.401 1713 456C1721.68 456.836 1730.29 457.14 1739 457.137C1741.28 457.13 1743.57 457.125 1745.86 457.13C1754.96 457.156 1763.94 456.966 1773 456C1771.94 453.221 1771.24 451.413 1770.27 449.771C1768.45 446.713 1765.66 444.234 1757.68 437.135L1755.81 435.5C1753.99 433.878 1752.28 432.368 1750.39 431.084C1750.11 430.864 1749.83 430.645 1749.55 430.428C1749.37 430.285 1749.19 430.142 1749 430C1745.34 427.831 1742.26 425.593 1739.09 422.773C1733.57 417.828 1727.93 413.073 1722.07 408.541L1719.81 406.812L1719.25 406.376L1719.1 406.263ZM1502 160C1503.09 160.835 1503.68 161.286 1504.23 161.776C1504.88 162.352 1505.49 162.98 1506.8 164.348L1509.51 167.123C1510.07 167.704 1510.62 168.285 1511.17 168.866L1511.74 169.463L1512.31 170.062C1514.14 171.952 1515.97 173.838 1517.8 175.723L1520.46 178.461C1523.36 181.355 1526.38 184.039 1529.53 186.658C1530.22 187.291 1530.59 187.626 1530.89 188.013C1531.22 188.446 1531.47 188.944 1532 190C1521.4 192.076 1511.13 192.316 1500.38 192.25L1497.84 192.245C1485.8 192.215 1473.92 191.849 1462 190C1464.54 184.458 1467.07 180.238 1471.44 176L1473 174.459C1480.34 167.49 1491.37 158.695 1502 160ZM1115.02 320.378C1108.51 309.745 1098.69 296.86 1087.09 292.239C1086.05 292.12 1085.53 292.061 1085.03 292.143C1084.52 292.227 1084.04 292.457 1083.07 292.921L1081.06 294.395L1078.8 296.028L1076.44 297.812C1075.31 298.646 1074.15 299.484 1072.97 300.334L1072.96 300.337C1065.74 305.544 1057.91 311.186 1054 319L1067 319.722V320L1090 321L1084 328H1119V326C1117.79 323.994 1116.48 322.106 1115.02 320.378Z",
    fill: "#1E1E1E",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.64 64.1682C1426.46 58.2896 1422.44 53.5904 1417.5 53.5904C1414.73 53.5904 1412.25 55.0718 1410.57 57.406C1409.84 52.9144 1406.55 49.522 1402.59 49.522C1400.95 49.522 1399.42 50.1118 1398.14 51.1186C1397.43 39.31 1389.23 29.9917 1379.22 29.9917C1370.11 29.9917 1362.51 37.6889 1360.66 47.9565C1358.81 46.4135 1356.56 45.5094 1354.14 45.5094C1347.8 45.5094 1342.66 51.6777 1342.66 59.2867C1342.66 61.0066 1342.93 62.6504 1343.41 64.1689H1426.64L1426.64 64.1682Z",
    fill: "#36A6C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.77 89.2321C1277.65 85.313 1274.96 82.1802 1271.65 82.1802C1269.79 82.1802 1268.12 83.1678 1267 84.724C1266.51 81.7295 1264.3 79.468 1261.65 79.468C1260.55 79.468 1259.52 79.8611 1258.67 80.5324C1258.19 72.6599 1252.69 66.4478 1245.98 66.4478C1239.87 66.4478 1234.77 71.5792 1233.54 78.4243C1232.3 77.3956 1230.79 76.7929 1229.16 76.7929C1224.91 76.7929 1221.47 80.9051 1221.47 85.9777C1221.47 87.1243 1221.65 88.2202 1221.97 89.2326H1277.77L1277.77 89.2321Z",
    fill: "#36A6C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063 113.999C1062.76 106.259 1057.4 100.072 1050.81 100.072C1047.12 100.072 1043.81 102.022 1041.57 105.096C1040.6 99.1815 1036.2 94.7149 1030.93 94.7149C1028.74 94.7149 1026.69 95.4914 1024.99 96.8171C1024.05 81.2691 1013.11 69 999.751 69C987.609 69 977.463 79.1346 975.007 92.6537C972.534 90.622 969.538 89.4316 966.3 89.4316C957.85 89.4316 951 97.5533 951 107.572C951 109.836 951.351 112.001 951.991 114H1063L1063 113.999Z",
    fill: "#36A6C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_2",
    x1: -0.0000428817,
    y1: 18.8766,
    x2: 1596.69,
    y2: 466.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1672A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803511,
    stopColor: "#0AA6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97DDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint516_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint517_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint518_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint519_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint520_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint521_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint522_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint523_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint524_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint525_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint526_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint527_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint528_linear_140_2",
    x1: 28.5,
    y1: 52.8261,
    x2: 649,
    y2: 552.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 720,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBg);
export default __webpack_public_path__ + "static/media/contact-bg.48e232a479d349c26ec2089c497f8b79.svg";
export { ForwardRef as ReactComponent };